<template>
  <div class="content-wrappper">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 heading">Product Classification</div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <p v-if="prodClassCriteria.current_slide_number == 0" class="sub_caption">
            Medical devices are classified according to the level of harm they may pose to users or
            patients. Based on your inputs our step-by-step guide suggests the medical device
            classification for multiple markets. Select from the Country list below to get started!
            We’ve also added a Classification Rationale report for Europe’s MDR regulations. The
            report leverages your inputs to the EU MDR classification questionnaire plus an optional
            review by an Emergo consultant to produce a rationale report that can be used in your
            Technical File or for strategic planning. This is our beta release so stay tuned for
            enhancements as we add markets and further refine the tool.
          </p>
          <p v-if="prodClassCriteria.current_slide_number != 0" class="sub_caption">
            {{ cases[prodClassCriteria.current_slide_number].caption }}
            <span class="sub_caption_bold">{{
              cases[prodClassCriteria.current_slide_number].sub_caption
            }}</span>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <ul class="crumb-trail">
            <li
              class="col-md-3 col-sm-3 col-lg-3 p-0"
              v-for="(case_item, index) in cases"
              v-bind:key="index"
              :class="{
                'is-active-slide col-xs-6': prodClassCriteria.current_slide_number === index,
                'col-xs-2': prodClassCriteria.current_slide_number !== index,
                completed_slide: prodClassCriteria.current_slide_number > index
              }"
            >
              <div class="crumb">
                <img
                  src="/static/images/icons/circle_check.svg"
                  class="breadcrumb-img"
                  alt="circle-icon"
                />
                <span>{{ case_item.title }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="tab-content">
            <div
              :class="{
                'tab-pane fade in active': prodClassCriteria.current_slide_number === 0,
                'tab-pane fade in ': prodClassCriteria.current_slide_number != 0
              }"
              id="createNewAlert1"
            >
              <div class="row">
                <div class="notification_box">
                  <div class="row padding_rl20">
                    <div class="col-md-11 class_question" style="padding-bottom: 10px">
                      Get started by telling us a little bit about your device.
                    </div>
                  </div>

                  <div class="row padding_rl20">
                    <div class="col-sm-4 col-md-4 col-lg-4 margin_bottom_15">
                      <span class="sub_heading">
                        What type of device are you registering?
                        <span class="required_astric">*</span>
                      </span>
                    </div>
                    <div class="col-sm-8 col-md-8 margin_bottom_15">
                      <div class="class-radio">
                        <div class="col-xs-12 col-sm-12 col-md-5 col-lg-4 pl-0">
                          <base-radio
                            class="class-radio__input general padding_rt10_lft0"
                            @click="filterCountries"
                            @change="filterCountries"
                            :name="devTypMD"
                            v-model="medical_device_type"
                            optionValue="GeneralMedicalDevice"
                            label="GeneralMedicalDevice"
                          >
                            General Medical Device
                          </base-radio>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-7 col-lg-8 pl-0">
                          <base-radio
                            class="class-radio__input general padding_rt10_lft0"
                            @click="filterCountries"
                            :name="devTypIVD"
                            v-model="medical_device_type"
                            @change="filterCountries"
                            optionValue="IVDMedicalDevice"
                            label="IVDMedicalDevice"
                          >
                            <span>In Vitro Diagnostic (IVD) Medical Device</span>
                          </base-radio>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row padding_rl20">
                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <span class="sub_heading">
                        Country
                        <span class="required_astric">*</span>
                      </span>
                    </div>
                    <div class="col-sm-4 col-md-4 margin_bottom_15">
                      <div class="search-input">
                        <multiselect
                          v-if="prodClassCriteria.filteredCountries.length"
                          :showLabels="false"
                          :close-on-select="true"
                          :allow-empty="false"
                          class="multiselect-single-dropdown"
                          :searchable="true"
                          :options="
                            prodClassCriteria.filteredCountries.map(
                              (country) => country.country_value
                            )
                          "
                          :custom-label="getCountryNameById"
                          v-model="prodClassCriteria.country"
                          @input="showCriteriaForCountry"
                          placeholder="Select Country"
                        >
                          <span slot="noResult">No matching data</span>
                        </multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="row padding_rl20">
                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <span class="sub_heading">
                        Device Name
                        <span class="required_astric">*</span>
                      </span>
                    </div>
                    <div class="col-sm-4 col-md-4 margin_bottom_15">
                      <div class="search-input">
                        <input
                          type="text"
                          class="form-control"
                          :class="
                            form_validation_messages['device_name']['displayError']
                              ? 'invalid-border'
                              : ''
                          "
                          @change="resetErrorMsg"
                          @focus="resetErrorMsg"
                          placeholder="Device Name"
                          v-model="prodClassCriteria.device_name"
                        />
                        <p
                          class="custom-error-class pt-8"
                          v-if="form_validation_messages['device_name']['displayError']"
                        >
                          {{ form_validation_messages['device_name']['errorMessage'] }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              :class="{
                'tab-pane fade in active': prodClassCriteria.current_slide_number === 1,
                'tab-pane fade in ': prodClassCriteria.current_slide_number != 1
              }"
              id="createNewAlert2"
            >
              <div class="row">
                <div class="notification_box">
                  <div
                    v-for="(classData, index) in prodClassCriteria.compositeArrayWrapper.dataArray"
                    v-bind:key="index"
                    class="padding_rl20"
                  >
                    <div class="padding_rt10_lft0 p-b10">
                      <span class="class_question">
                        <span v-html="classData.vital_characteristic"></span>
                        <div
                          v-if="
                            classData.children &&
                            classData.children[1] &&
                            classData.children[1].characteristic_type == 'NumberEntry'
                          "
                        >
                          New
                        </div>
                      </span>
                    </div>
                    <div class="padding_rt10_lft0 p-b10">
                      <span v-html="classData.explanatory_text"></span>
                    </div>
                    <div v-for="(option, index) in classData.children" v-bind:key="index">
                      <div
                        v-if="
                          option.characteristic_type !== 'NumberEntry' &&
                          classData.multi_select == 'Y'
                        "
                        class="mt-3 mb-5"
                      >
                        <span class="checkbox mr-12">
                        <label>
                          <input
                            type="checkbox"
                            v-model="prodClassCriteria.selectedChoices"
                            @change="
                              choicesChanged(
                                option.vital_characteristic +
                                  '|' +
                                  option.characteristic_type +
                                  '|' +
                                  option.level +
                                  '|' +
                                  option.classification_code +
                                  '|' +
                                  option.classification_notes +
                                  '|' +
                                  option.intrim_class +
                                  '|' +
                                  option.rule_ref +
                                  '|' +
                                  classData.vital_characteristic +
                                  '|' +
                                  option.intrim_class +
                                  '|' +
                                  option.class_override +
                                  '|' +
                                  option.highest_class_override
                              )
                            "
                            :id="
                              option.vital_characteristic +
                              '_' +
                              option.characteristic_type +
                              '_' +
                              option.level
                            "
                            class="tools_check vital-char-style m-r-14"
                            :disabled="disabledChoices.includes(option.level)"
                            :value="
                              option.vital_characteristic +
                              '|' +
                              option.characteristic_type +
                              '|' +
                              option.level +
                              '|' +
                              option.classification_code +
                              '|' +
                              option.classification_notes +
                              '|' +
                              option.intrim_class +
                              '|' +
                              option.rule_ref +
                              '|' +
                              classData.vital_characteristic +
                              '|' +
                              option.intrim_class +
                              '|' +
                              option.class_override +
                              '|' +
                              option.highest_class_override
                            "
                          />
                          <span class="cr"></span>
                        </label>
                      </span>
                      <span class="vital-char-style">{{ option.vital_characteristic }}</span>
                    </div>
                      <div v-else-if="option.characteristic_type === 'Response'">
                        <div class="search-input">
                          <input
                            type="text"
                            v-model="prodClassCriteria.componentName[ivdrCurrCtr]"
                            @keydown="
                              responseChanged(
                                option.vital_characteristic +
                                  '|' +
                                  option.characteristic_type +
                                  '|' +
                                  option.level +
                                  '|' +
                                  option.classification_code +
                                  '|' +
                                  option.classification_notes +
                                  '|' +
                                  option.intrim_class +
                                  '|' +
                                  option.rule_ref +
                                  '|' +
                                  classData.vital_characteristic +
                                  '|' +
                                  option.intrim_class +
                                  '|' +
                                  option.class_override +
                                  '|' +
                                  option.highest_class_override
                              )
                            "
                            :id="
                              option.vital_characteristic +
                              '_' +
                              option.characteristic_type +
                              '_' +
                              option.level
                            "
                            class="form-control tf-width-20"
                            :class="
                              form_validation_messages['ivdr_component_name']['displayError'] ||
                              form_validation_messages['ivdr_duplicate_component']['displayError']
                                ? 'invalid-border'
                                : ''
                            "
                            :disabled="disabledChoices.includes(option.level)"
                          />
                          <p
                            class="custom-error-class pt-8"
                            v-if="form_validation_messages['ivdr_component_name']['displayError']"
                          >
                            {{ form_validation_messages['ivdr_component_name']['errorMessage'] }}
                          </p>
                          <p
                            class="custom-error-class pt-8"
                            v-if="
                              form_validation_messages['ivdr_duplicate_component']['displayError']
                            "
                          >
                            {{
                              form_validation_messages['ivdr_duplicate_component']['errorMessage']
                            }}
                          </p>
                        </div>
                        <span class="el-checkbox__label">
                          <label
                            class="vital-char-style"
                            :for="
                              option.vital_characteristic +
                              '_' +
                              option.characteristic_type +
                              '_' +
                              option.level
                            "
                          >
                            <span class="class_answer question_details">
                              <base-tooltip :content="option.level" v-if="info == true">
                                <span class="email_tooltip">
                                  <i class="fa fa-question-circle"></i>
                                </span>
                              </base-tooltip>
                            </span>
                          </label>
                        </span>
                      </div>
                      <div v-else>
                        <div class="class-radio m-t-3">
                          <p class="">
                            <base-radio
                              class="class-radio__input"
                              @click="optionPicked"
                              @change="optionPicked"
                              :id="
                                option.vital_characteristic +
                                '_' +
                                option.characteristic_type +
                                '_' +
                                option.level
                              "
                              :name="option.id + '-' + option.level"
                              v-model="prodClassCriteria.selectedOptions"
                              :optionValue="
                                option.vital_characteristic +
                                '|' +
                                option.characteristic_type +
                                '|' +
                                option.level +
                                '|' +
                                option.classification_code +
                                '|' +
                                option.classification_notes +
                                '|' +
                                option.intrim_class +
                                '|' +
                                option.rule_ref +
                                '|' +
                                classData.vital_characteristic +
                                '|' +
                                option.intrim_class +
                                '|' +
                                option.class_override +
                                '|' +
                                option.highest_class_override
                              "
                              :label="
                                option.vital_characteristic +
                                '|' +
                                option.characteristic_type +
                                '|' +
                                option.level +
                                '|' +
                                option.classification_code +
                                '|' +
                                option.classification_notes +
                                '|' +
                                option.intrim_class +
                                '|' +
                                option.rule_ref +
                                '|' +
                                classData.vital_characteristic +
                                '|' +
                                option.intrim_class +
                                '|' +
                                option.class_override +
                                '|' +
                                option.highest_class_override
                              "
                            >
                            <span class="vital-char-style">{{
                                option.vital_characteristic
                              }}</span>
                            </base-radio>
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="pl-30 p-b10" v-if="option.explanatory_text">
                          <span
                            class="padding_rt10_lft4 cust-margin"
                            v-html="option.explanatory_text"
                          ></span>
                        </div>
                        <div
                          class="col-md-3 search-input"
                          v-if="
                            ivdrKitFlow &&
                            option.vital_characteristic === 'Yes' &&
                            option.level === '10-1' &&
                            prodClassCriteria.country === 'EU IVDR'
                          "
                        >
                          <span>
                            <input
                              type="text"
                              class="form-control tf-width-20"
                              :class="
                                form_validation_messages['ivdr_total_components']['displayError'] ||
                                form_validation_messages['ivdr_invalid_components']['displayError']
                                  ? 'invalid-border'
                                  : ''
                              "
                              @change="resetErrorMsg"
                              @focus="resetErrorMsg"
                              placeholder="Number of kit components"
                              v-model="ivdrTotalComponents"
                            />
                            <p
                              class="custom-error-class pt-8"
                              v-if="
                                form_validation_messages['ivdr_total_components']['displayError']
                              "
                            >
                              {{
                                form_validation_messages['ivdr_total_components']['errorMessage']
                              }}
                            </p>
                            <p
                              class="custom-error-class pt-8"
                              v-if="
                                form_validation_messages['ivdr_invalid_components']['displayError']
                              "
                            >
                              {{
                                form_validation_messages['ivdr_invalid_components']['errorMessage']
                              }}
                            </p></span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              :class="{
                'tab-pane fade in active': prodClassCriteria.current_slide_number === 2,
                'tab-pane fade in ': prodClassCriteria.current_slide_number != 2
              }"
              id="createNewAlert3"
            >
              <div v-if="!ivdrKitFlow">
                <classification-summary
                  :info="info"
                  :debug="debug"
                  :ivdrCurrCtr="ivdrCurrCtr"
                  :prodClassCriteria="prodClassCriteria"
                ></classification-summary>
              </div>
              <div v-if="ivdrKitFlow">
                <classification-summary-kit
                  :info="info"
                  :debug="debug"
                  :ivdrCurrCtr="ivdrCurrCtr"
                  :ivdrTotalComponents="ivdrTotalComponents"
                  :prodClassCriteria="prodClassCriteria"
                ></classification-summary-kit>
              </div>
            </div>
            <div
              v-if="prodClassCriteria.country === 'EU IVDR'"
              :class="{
                'tab-pane fade in active': prodClassCriteria.current_slide_number === 2,
                'tab-pane fade in ': prodClassCriteria.current_slide_number != 2
              }"
              id="createNewAlert3"
            ></div>
            <div
              :class="{
                'tab-pane fade in active': prodClassCriteria.current_slide_number === 3,
                'tab-pane fade in ': prodClassCriteria.current_slide_number != 3
              }"
              id="createNewAlert4"
            >
              <classification-result-page
                :info="info"
                :account_id="account_id"
                :roleId="roleId"
                :userId="userId"
                v-if="!ivdrKitFlow"
                :debug="debug"
                :ivdrCurrCtr="ivdrCurrCtr"
                :pageConfig="pageConfig"
                :ivdrKitFlow="ivdrKitFlow"
                :kitClassSummary="kitClassSummary"
                :prodClassCriteria="prodClassCriteria"
              >
              </classification-result-page>

              <classification-result-page-kit
                :info="info"
                v-if="ivdrKitFlow"
                :account_id="account_id"
                :roleId="roleId"
                :userId="userId"
                :debug="debug"
                :ivdrCurrCtr="ivdrCurrCtr"
                :pageConfig="pageConfig"
                :ivdrKitFlow="ivdrKitFlow"
                :kitClassSummary="kitClassSummary"
                :prodClassCriteria="prodClassCriteria"
              >
              </classification-result-page-kit>
            </div>
            <!---->
          </div>
        </div>
      </div>
      <div class="row">
        <div
          class="col-lg-12 col-md-12 col-ms-12 col-xs-12"
          v-if="validationMsg && prodClassCriteria.current_slide_number > 0"
        >
          <div class="alert alert-danger error-msg">{{ validationMsg }}</div>
        </div>
      </div>

      <div class="row case-slider__navigation margin_top_bottom_15">
        <div
          class="col-lg-3 col-md-3 col-sm-12 col-xs-12"
          v-if="
            prodClassCriteria.current_slide_number != 0 &&
            this.prodClassCriteria.classificationFinalized == false
          "
        >
          <button class="btn btn-block emergo-white-button m-t5" @click="backWrapper">Back</button>
        </div>
        <div
          class="col-lg-3 col-md-3 col-sm-12 col-xs-12"
          v-if="
            prodClassCriteria.current_slide_number != 0 &&
            this.prodClassCriteria.classificationFinalized === true
          "
        ></div>
        <div class="col-lg-3 col-md-3 col-xs-12 col-sm-12">
          <button
            v-if="prodClassCriteria.current_slide_number == 0"
            id="footerNext"
            class="btn btn-block emergo-green-button m-t5"
            data-toggle="tab"
            :disabled="this.validationMsg !== ''"
            @click="validateForm"
          >
            Next
          </button>
          <button
            v-if="
              prodClassCriteria.current_slide_number > 0 &&
              prodClassCriteria.current_slide_number < 2
            "
            id="footerNext"
            class="btn btn-block emergo-green-button m-t5"
            data-toggle="tab"
            :disabled="
              this.validationMsg !== '' ||
              form_validation_messages['ivdr_total_components']['displayError'] ||
              ivdrTotalComponents === 1
            "
            @click="nextValidate"
          >
            Next
          </button>

          <button
            v-if="
              prodClassCriteria.current_slide_number == 2 &&
              permissions.includes('CLASSIFICATION_RESULTS') &&
              !ivdrKitFlow
            "
            id="footerNext"
            class="btn btn-block emergo-green-button m-t5"
            data-toggle="tab"
            @click="finalizeClassification"
          >
            Result
          </button>
          <button
            v-if="
              prodClassCriteria.current_slide_number == 2 &&
              permissions.includes('CLASSIFICATION_RESULTS') &&
              ivdrKitFlow &&
              prodClassCriteria.country === 'EU IVDR' &&
              ivdrTotalComponents > ivdrCurrCtr
            "
            id="footerNext"
            class="btn btn-block emergo-green-button m-t5"
            data-toggle="tab"
            @click="continueKitComponent"
          >
            Classify Remaining Components
          </button>
          <button
            v-if="
              prodClassCriteria.current_slide_number == 2 &&
              permissions.includes('CLASSIFICATION_RESULTS') &&
              ivdrKitFlow &&
              ivdrTotalComponents == ivdrCurrCtr
            "
            id="footerNext"
            class="btn btn-block emergo-green-button m-t5"
            data-toggle="tab"
            @click="finalizeClassificationKit"
          >
            Finalize Results
          </button>
          <button
            v-if="
              this.prodClassCriteria.classificationFinalized == true &&
              prodClassCriteria.current_slide_number == 3
            "
            class="btn btn-block emergo-white-button m-t5"
            @click="startOver"
          >
            Start Over
          </button>
        </div>
        <div
          class="col-lg-3 col-md-3 col-sm-12 col-xs-12"
          v-if="
            this.prodClassCriteria.classificationFinalized == false &&
            (prodClassCriteria.current_slide_number === 2 ||
              prodClassCriteria.current_slide_number === 1)
          "
        >
          <button
            id="footerNext"
            class="btn btn-block emergo-white-button m-t5"
            data-toggle="tab"
            @click="startOver"
          >
            Start Over
          </button>
        </div>
        <div
          class="col-lg-3 col-md-4 col-sm-12 col-xs-12"
          v-if="prodClassCriteria.current_slide_number <= 3"
        >
          <button
            id="footerNext"
            class="btn btn-block emergo-blue-button m-t5"
            data-toggle="tab"
            @click="navProdClassDashboard"
          >
            Back To Dashboard
          </button>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" v-if="atleastOneReportReady === true">
        <div class="row">
          <classification-debug-kit
            :dtlDebug="lowDebug"
            v-if="ivdrKitFlow"
            :mainDebug="debug"
            :prodClassCriteria="prodClassCriteria"
            :ivdrCurrCtr="ivdrCurrCtr"
            :criteriaMap="searchCriteriaMap"
          ></classification-debug-kit>
          <classification-debug
            :dtlDebug="lowDebug"
            v-else
            :mainDebug="debug"
            :prodClassCriteria="prodClassCriteria"
            :ivdrCurrCtr="ivdrCurrCtr"
            :criteriaMap="searchCriteriaMap"
          ></classification-debug>
        </div>
      </div>
    </div>
    <uk-disclaimer-modal></uk-disclaimer-modal>
    <complimentary-access-popup></complimentary-access-popup>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
import $ from 'jquery';
import Loader from '../UIComponents/Loader.vue';
import BaseTooltip from '../Common/BaseTooltip.vue';
import { countryData } from '../../../public/static/json/countryData.json';
import { allValidationRules } from '../../../public/static/json/prod-class-validation-rules.json';
import { deviceTypeArray } from '../../../public/static/json/prod-class-deviceType-country-map.json';
import { prodClassData } from '../../../public/static/json/prodClassData.json';
import ClassificationDebug from './ProdClassificationDebug.vue';
import ClassificationDebugKit from './IVDR/ProdClassificationDebug.vue';

import ClassificationResultPage from './ProductClassificationResultPage.vue';
import ClassificationResultPageKit from './ProductClassificationResultPageKit.vue';
import ClassificationSummary from './ProductClassificationSummary.vue';
import ClassificationSummaryKit from './ProductClassificationSummaryKit.vue';

import GenericPopup from '../UIComponents/GenericPopup.vue';
import UpgradeModal from '../ProfileAccountSettings/CommonComponents/UpgradeModal.vue';
import UkDisclaimerModal from './UKDisclaimerModal.vue';
import ComplimentaryAccessPopup from './ComplimentaryAccessPopupModal.vue';
import permissionsList from '../UIComponents/mixins/rbacPermissionsMixin';

import {
  getClassificationsUsingAttrWrapper,
  postProdClassWorkFlowHeader,
  getProdClassConfig,
  getProdClassUsageFlag
} from '../../apis/prodClassification';
import { getSubscribedPlans } from '../../apis/plans';

import { getAddonDetails, getAvailableCapacity } from '../../apis/psm';
import BaseRadio from '../Common/BaseRadio.vue';

const CLASSI = 'Class I';
const LEVEL_ARR = ['43', '44'];
const SELECT_RESPONSE = 'Please select a response';
const NAV_DIR_FORWARD = 'F';
const NAV_DIR_BACKWARD = 'B';
const PROD_CLASS_RATIONALE_PLAN_ID = 9;

const EU_MDR = 'EU MDR';
const EU_MDR_SPL_RULE = '41';
const EU_IVDR = 'EU IVDR';

export default {
  mixins: [permissionsList],
  async mounted() {
    this.loaderStatus = true;
    await this.getCountries();
    if (this.$route.query.debug && this.$route.query.debug === 'true') {
      this.debug = true;
    }
    if (this.$route.query.info && this.$route.query.info === 'true') {
      this.info = true;
    }
    if (this.$route.query.jumpToStep) {
      this.current_slide_number = 3;
    }
    this.filterCountries();
    // this.atleastOneReportReady = this.findIfAnyReportsPending();
    this.atleastOneReportReady = true;
    await this.loadConfig();
    await this.initializePage();
    if (this.searchCriteria) {
      this.prodClassCriteria.current_slide_number = 2;
    }
    this.loaderStatus = false;
  },
  async created() {
    if (this.$route.query.debug && this.$route.query.debug === 'true') {
      this.debug = true;
    }
    if (this.$route.query.info && this.$route.query.info === 'true') {
      this.info = true;
    }
    if (this.$route.query.jumpToStep) {
      this.current_slide_number = 3;
    }
    await this.validateFeatures();
  },
  components: {
    ClassificationDebug,
    ClassificationDebugKit,
    GenericPopup,
    UpgradeModal,
    ClassificationSummary,
    ClassificationSummaryKit,
    ClassificationResultPage,
    ClassificationResultPageKit,
    Loader,
    BaseTooltip,
    UkDisclaimerModal,
    ComplimentaryAccessPopup,
    BaseRadio
  },
  props: ['account_id', 'roleId', 'userId', 'searchCriteria'],
  data() {
    return {
      prodClassTrialAccessAllowed: false,
      medical_device_type: 'GeneralMedicalDevice',
      devTypIVD: '',
      devTypMD: '',
      GeneralMedicalDevice: '',
      IVDMedicalDevice: '',
      kitClassSummary: {},
      ivdrKitFlow: false,
      ivdrTotalComponents: 2,
      ivdrCurrCtr: 0,
      currLevel: [],
      permissions: [],
      genericPopupId: 'genericPopupAddPathway',
      max_classification_allowed: 2,
      regPathwayPlanRouteMap: new Map(),
      addonDetails: [],
      classificationAddonAvailable: true, // A flag to indicate whether any capacity remains of user needs to be asked to buy more add ons.
      classificationAddonObj: {},
      prodClassCriteriaObjectMap: new Map(),
      pageConfig: {},
      addedPlans: [],
      prodClassCriteria: {
        componentName: [],
        filteredCountries: [],
        country: 'EU MDD',
        device_name: null,
        selectedOptions: '',
        selectedChoices: [],
        ivdrClassDataArray: [],
        searchCriteriaArray: [],
        workflowResponseCache: [],
        ruleRefArray: [],
        levelArray: [],
        mapLevelArray: new Map(),
        selectedCb: true,
        interimClassDataArray: [],
        interimClassMap: new Map(),
        workflowResponseMap: new Map(),
        current_slide_number: 0,
        classificationFinalized: false,
        compositeArrayWrapper: {
          classFoundFlag: false,
          classNotes: '',
          classCode: '',
          classRuleRef: 3,
          dataArray: []
        },
        headerId: ''
      },
      choiceFlag: false,
      optionsFlag: false,
      searchCriteriaMap: new Map(),
      searchCriteriaMapKit: new Map(),
      levelArrayMap: new Map(),
      selectedOptions: '',
      highestClassOverrideFlag: false,
      terminating: false,
      disabledChoices: [],
      form_validation_messages: {
        device_name: {
          displayError: false,
          errorMessage: 'Device name is required'
        },
        work_flow: {
          displayError: false,
          errorMessage: 'Select a response>'
        },
        ivdr_total_components: {
          displayError: false,
          errorMessage: 'There should be atleast 2 components to qualify.'
        },
        ivdr_invalid_components: {
          displayError: false,
          errorMessage: 'Use a numeric value for no of components.'
        },
        ivdr_component_name: {
          displayError: false,
          errorMessage: 'Please supply a proper component name.'
        },
        ivdr_duplicate_component: {
          displayError: false,
          errorMessage: 'Component name should be unique.'
        }
      },
      classWorkFlowData: {
        header: {},
        details: []
      },
      speciality: '',
      ruleSearchQuery: {
        class_node_request: {
          market:
            this.prodClassCriteria && this.prodClassCriteria.country
              ? this.prodClassCriteria.country
              : 'EU MDD',
          vital_characteristic: null,
          characteristic_type: 'Option',
          level: null
        },
        steps: []
      },
      cases: [
        {
          id: 1,
          title: 'General',
          caption: 'Get started by telling us a little bit about your device.',
          sub_caption: ''
        },
        {
          id: 2,
          title: 'Questionnaire',
          caption:
            'Your answers in this section will help us narrow down the classification of your device.',
          sub_caption: ''
        },
        {
          id: 3,
          title: 'Summary',
          caption: '',
          sub_caption:
            'Please take a moment to review your answers. Once the Classification result is provided you will not be able to change your responses.'
        },
        {
          id: 4,
          title: 'Classification',
          caption:
            'This tool is our beta release and we continue to make enhancements. We’d love to hear about your experience and how well our Classification tool worked for you. Please click on the Feedback button above.',
          sub_caption: ''
        }
      ],
      countriesData: { countries: [] },
      loaderStatus: false,
      compositeArray: [],
      productClassData: [],
      validationMsg: SELECT_RESPONSE,
      activeName: '1',
      debug: false,
      info: false,
      lowDebug: true,
      multi_select: false,
      activeNames: [''],
      navDir: NAV_DIR_FORWARD,
      atleastOneReportReady: false,
      recordAddonService: null,
      teamAddonService: null,
      selectedPlan: {}
    };
  },

  computed: {
    /* rationaleReqs() {
      return prodClassData.rationalReportRequests[0].classRationalRequests;
    },
    searchCriteriaArray() {
      return this.prodClassCriteria.searchCriteriaArray;
    }, */
    selectedOptionsWatch() {
      return this.prodClassCriteria.selectedOptions;
    },
    /* compArrWrapperWatch() {
      return this.prodClassCriteria.compositeArrayWrapper;
    }, */
    selectedCheckboxesWatch() {
      return this.prodClassCriteria.selectedChoices;
    },
    componentNameWatch() {
      return this.prodClassCriteria.componentName;
    },
    interimClassMapWatch() {
      return this.prodClassCriteria.interimClassMap;
    },
    /**
     * Utility methods for getting array lengths.
     */
    arrayLengths() {
      const arrLengthHolder = {
        srch_cri_arr_len: this.prodClassCriteria.searchCriteriaArray
          ? this.prodClassCriteria.searchCriteriaArray.length
          : null,
        wf_resp_arr: this.prodClassCriteria.workflowResponseCache
          ? this.prodClassCriteria.workflowResponseCache.length
          : null
      };
      return arrLengthHolder;
    },
    /* workflowDataArray() {
      const workflowDataArray = [];
      let indx = 0;
      const wfResponseCache = this.prodClassCriteria.workflowResponseCache;
      if (wfResponseCache && wfResponseCache.length > 0) {
        wfResponseCache.forEach((srchCritArrElement) => {
          if (srchCritArrElement) {
            const currTitleDataAndChildOptions = srchCritArrElement.response_data;
            const choicesVar = srchCritArrElement.choices;
            let answerVal = '';
            const levelComputed = [];
            let ruleRefVal = '';
            let intClass = '';
            let classCodeComp = '';
            let classNotes = '';
            if (Array.isArray(choicesVar)) {
              choicesVar.forEach((e) => {
                const valArray = e.split('|');
                answerVal = `${answerVal}  ${valArray[0]} <BR> `;
                levelComputed.push(valArray[2]);

                const rlRefTmp = !valArray[6] ? `${valArray[6]} ,` : '';
                ruleRefVal = `${ruleRefVal}  ${rlRefTmp}`;
                const intClsTmp = !valArray[5] ? `${valArray[5]}  ,` : '';
                intClass = `${intClass} ${intClsTmp}`;
              });
            } else {
              const valArray = choicesVar.split('|');
              const reqValArray = [valArray[0], valArray[3], valArray[5], valArray[6], valArray[4]];
              const [answerComp, classCdComp, intClsComp, ruleRefComp, classNotesComp] =
                reqValArray;
              answerVal = answerComp;
              levelComputed.push(valArray[2]);
              ruleRefVal = ruleRefComp;
              intClass = intClsComp;
              classCodeComp = classCdComp;
              classNotes = classNotesComp;
            }
            const workflowDataIns = {
              step: indx,
              question: currTitleDataAndChildOptions.vital_characteristic,
              answer: answerVal,
              level: levelComputed,
              interimClass: intClass,
              classCode: classCodeComp,
              classNote: classNotes,
              ruleRef: ruleRefVal
            };
            indx += 1;
            workflowDataArray.push(workflowDataIns);
          }
        });
      }
      return workflowDataArray;
    }, */
    /**
     * This method uses interim class data's array and hides all complex logic and only exposes simple data to template.
     *
     */
    summarizedRiskClassRules() {
      const summarizedObj = {
        applicableRules: [],
        resultingRiskClass: [],
        highestClassRules: []
      };
      let doOverRide = false;
      for (let idx = 0; idx < this.prodClassCriteria.interimClassDataArray.length; ) {
        const intrimDataIns = this.prodClassCriteria.interimClassDataArray[idx];
        if (intrimDataIns && intrimDataIns.int_class) {
          const applRuleVal = `${intrimDataIns.int_class_rule} (  ${intrimDataIns.int_class} )`;
          if (!summarizedObj.applicableRules.includes(applRuleVal)) {
            summarizedObj.applicableRules.push(applRuleVal);
          }
          if (intrimDataIns.class_override === 'Y') {
            doOverRide = true;
          } else if (!summarizedObj.resultingRiskClass[0]) {
            summarizedObj.resultingRiskClass[0] = intrimDataIns.int_class;
            summarizedObj.resultingRiskClass[1] = intrimDataIns.class_notes;
          } else if (
            intrimDataIns.int_class.localeCompare(summarizedObj.resultingRiskClass[0]) > 0
          ) {
            summarizedObj.resultingRiskClass[0] = intrimDataIns.int_class;
            summarizedObj.resultingRiskClass[1] = intrimDataIns.class_notes;
          }
        }
        idx += 1;
      }
      /* This check required to do a proper override.Blood bags will always be Class IIb. */
      if (doOverRide === true) {
        if (
          this.prodClassCriteria.interimClassDataArray.filter(
            (element) => element.class_override === 'Y'
          )
        ) {
          summarizedObj.resultingRiskClass[0] = this.prodClassCriteria.interimClassDataArray.filter(
            (element) => element.class_override === 'Y'
          )[0].int_class;
          summarizedObj.resultingRiskClass[1] = this.prodClassCriteria.interimClassDataArray.filter(
            (element) => element.class_override === 'Y'
          )[0].class_notes;
        }
      }

      this.prodClassCriteria.interimClassDataArray.forEach((intrimDataIns) => {
        if (intrimDataIns) {
          if (
            summarizedObj.resultingRiskClass[0] === intrimDataIns.int_class &&
            !summarizedObj.highestClassRules.includes(intrimDataIns.int_class_rule)
          ) {
            summarizedObj.highestClassRules.push(intrimDataIns.int_class_rule);
          }
        }
      });
      summarizedObj.highestClassRules.sort((a, b) => b - a);
      // this.prodClassCriteria.compositeArrayWrapper.classRuleRef = summarizedObj.highestClassRules[0];
      return summarizedObj;
    },
    summarizedRiskRules() {
      const summarizedObj = {
        applicableRules: [],
        resultingRiskClass: [],
        highestClassRules: []
      };
      let doOverRide = false;
      let intClsArrayFiltered = this.prodClassCriteria.interimClassDataArray;
      if (this.prodClassCriteria.country === EU_MDR) {
        intClsArrayFiltered = this.prodClassCriteria.interimClassDataArray.filter(
          (e) => e.level.split('-')[0] !== EU_MDR_SPL_RULE
        );
      }

      for (let idx = 0; idx < intClsArrayFiltered.length; ) {
        const intrimDataIns = intClsArrayFiltered[idx];
        if (intrimDataIns && intrimDataIns.int_class) {
          const applRuleVal = `${intrimDataIns.int_class_rule} (  ${intrimDataIns.int_class} )`;
          if (!summarizedObj.applicableRules.includes(applRuleVal)) {
            summarizedObj.applicableRules.push(applRuleVal);
          }
          if (intrimDataIns.class_override === 'Y') {
            doOverRide = true;
          } else if (!summarizedObj.resultingRiskClass[0]) {
            summarizedObj.resultingRiskClass[0] = intrimDataIns.int_class;
            summarizedObj.resultingRiskClass[1] = intrimDataIns.class_notes;
          } else if (
            intrimDataIns.int_class.localeCompare(summarizedObj.resultingRiskClass[0]) > 0
          ) {
            summarizedObj.resultingRiskClass[0] = intrimDataIns.int_class;
            summarizedObj.resultingRiskClass[1] = intrimDataIns.class_notes;
          }
        }
        idx += 1;
      }
      /* This check required to do a proper override.Blood bags will always be Class IIb. */
      if (doOverRide === true) {
        if (intClsArrayFiltered.filter((element) => element.class_override === 'Y')) {
          summarizedObj.resultingRiskClass[0] = intClsArrayFiltered.filter(
            (element) => element.class_override === 'Y'
          )[0].int_class;
          summarizedObj.resultingRiskClass[1] = intClsArrayFiltered.filter(
            (element) => element.class_override === 'Y'
          )[0].class_notes;
        }
      }

      const excludeClassArray = ['Class I s'];
      const intClassArrFiltered = intClsArrayFiltered.filter(
        (element) => !excludeClassArray.includes(element.int_class)
      );

      intClassArrFiltered.forEach((intrimDataIns) => {
        if (intrimDataIns) {
          if (
            summarizedObj.resultingRiskClass[0] !== 'Class I s' &&
            summarizedObj.resultingRiskClass[0] === intrimDataIns.int_class &&
            !summarizedObj.highestClassRules.includes(intrimDataIns.int_class_rule)
          ) {
            summarizedObj.highestClassRules.push(intrimDataIns.int_class_rule);
          }
        }
      });
      summarizedObj.highestClassRules.sort((a, b) => b - a);

      if (summarizedObj.highestClassRules && summarizedObj.highestClassRules[0] === null) {
        summarizedObj.highestClassRules.shift();
      }
      return summarizedObj;
    }
  },
  watch: {
    componentNameWatch(value) {
      if (value[this.ivdrCurrCtr] && value[this.ivdrCurrCtr].length > 0) {
        this.form_validation_messages.ivdr_component_name.displayError = false;
      }
      if (value.length > 1 && value.includes(value[this.ivdrCurrCtr])) {
        const compNameArrayClone = [...value];
        compNameArrayClone.pop();
        if (compNameArrayClone.includes(value[this.ivdrCurrCtr]))
          this.form_validation_messages.ivdr_duplicate_component.displayError = true;
        else this.form_validation_messages.ivdr_duplicate_component.displayError = false;
      }
    },
    ivdrTotalComponents(query) {
      // total no of components is a valid number and greater than or equals to 2.
      if (this.prodClassCriteria.country === EU_IVDR && !query) {
        this.form_validation_messages.ivdr_total_components.displayError = true;
        this.form_validation_messages.ivdr_invalid_components.displayError = false;
      } else if (query && query.length > 0) {
        const check = /^\d+$/.test(query);
        if (check === false) {
          this.form_validation_messages.ivdr_invalid_components.displayError = true;
          this.form_validation_messages.ivdr_total_components.displayError = false;
        } else if (query < 2) {
          this.form_validation_messages.ivdr_total_components.displayError = true;
          this.form_validation_messages.ivdr_invalid_components.displayError = false;
        } else {
          this.form_validation_messages.ivdr_total_components.displayError = false;
          this.form_validation_messages.ivdr_invalid_components.displayError = false;
        }
      }
      if (this.prodClassCriteria.country === EU_IVDR) {
        this.ruleSearchQuery.class_node_request.multi_device =
          !this.form_validation_messages.ivdr_total_components.displayError &&
          !this.form_validation_messages.ivdr_invalid_components.displayError;
      }
    },
    interimClassWatch(intClassMp) {
      this.prodClassCriteria.interimClassDataArray = [...intClassMp.values()];
    },
    /** Called when answers radio button is selected */
    async selectedOptionsWatch(selOptvalue) {
      if (
        this.valAtIndex(selOptvalue, 2) === '10-1' &&
        this.valAtIndex(selOptvalue, 0) === 'Yes' &&
        this.medical_device_type === 'IVDMedicalDevice'
      ) {
        this.ivdrKitFlow = true;
      }
      if (this.valAtIndex(selOptvalue, 2) === '10-2' && this.valAtIndex(selOptvalue, 0) === 'No') {
        this.ivdrKitFlow = false;
        this.form_validation_messages.ivdr_total_components.displayError = false;
      }
      this.selectedOptionsWatchUtil(selOptvalue);
      this.levelArrayVals();
    },
    /**
     * Called when user checks multiple options questions.
     */
    selectedCheckboxesWatch(selChoiceVal) {
      let levelInt;
      if (selChoiceVal && selChoiceVal.length > 0) {
        const levelVal = this.currLevel[this.currLevel.length - 1];
        levelInt = levelVal.substring(0, levelVal.indexOf('-'));
        const localChoicesArray = [];
        selChoiceVal.forEach((choiceVal) => {
          // Add only elements whose level matches current level. Otherwise all (other level) data also gets mixed with current level
          // This is applicable for multiselect data only. EU MDD/MDR and AUS/NZ.
          if (levelInt === choiceVal.split('|')[2].substring(0, levelVal.indexOf('-'))) {
            localChoicesArray.push(choiceVal);
          }
        });
        this.searchCriteriaMap.set(levelInt, localChoicesArray);
        this.choiceFlag = true;
      } else {
        this.choiceFlag = false;
      }
      let levelVals = [];
      selChoiceVal.forEach((indVal) => {
        const levelValVar = indVal.split('|')[2];
        const levelIndVal = levelValVar.substring(0, levelValVar.indexOf('-'));
        if (levelInt === levelIndVal) {
          levelVals.push(levelValVar);
        }
      });
      levelVals = levelVals.sort(
        (a, b) =>
          a.substring(a.indexOf('-'), a.length - 1) - b.substring(b.indexOf('-'), b.length - 1)
      );
      if (selChoiceVal && selChoiceVal.length > 0) {
        this.levelArrayMap.set(levelInt, levelVals);
      } else if (selChoiceVal && selChoiceVal.length === 0) {
        this.levelArrayMap.delete(levelInt);
      }
      if (selChoiceVal.length === 0 || !selChoiceVal) {
        this.validationMsg = '';
      }
      this.resetRuleSearchQuery();
      if (selChoiceVal.length !== 0) {
        const selectedOptArr = [...selChoiceVal];
        const selectedOptArrFilterArray = selectedOptArr.filter(
          (element) =>
            element.split('|')[2].substring(0, element.split('|')[2].indexOf('-')) === levelInt
        );
        selectedOptArrFilterArray.sort((selChoA, selChoB) => {
          const suffxIntVala = selChoA
            .split('|')[2]
            .substring(selChoA.split('|')[2].indexOf('-') + 1);
          const suffxIntValb = selChoB
            .split('|')[2]
            .substring(selChoB.split('|')[2].indexOf('-') + 1);
          return suffxIntVala - suffxIntValb;
        });
        // Get the element with lowest
        const vitChar = selectedOptArrFilterArray[0]
          ? selectedOptArrFilterArray[0].split('|')[0]
          : null;
        this.ruleSearchQuery.class_node_request.vital_characteristic = vitChar;
        // Process differently for multi_select 'Y' and NULL or 'N'
        this.ruleSearchQuery.class_node_request.level = this.computeLevel(
          this.currLevel[this.currLevel.length - 1]
        ).join(',');
        this.ruleSearchQuery.steps = this.levelArrayVals();
        this.manageInterimClassMap(selChoiceVal[0].split('|'));
      }
    }
  },
  methods: {
    getRuleLevel(currentChoice) {
      return currentChoice.split('|')[2];
    },
    summarizeClassInfo() {
      const classSummary = {
        classCode: null,
        classNotes: null,
        classCodePfx: null,
        classCodeSfx: null,
        ruleRef: 99
      };
      const entryArr = [...this.prodClassCriteria.workflowResponseMap.entries()];
      for (let i = 0; i < entryArr.length; i += 1) {
        const cacheCmp = entryArr[i];
        if (classSummary.classCode !== null && classSummary.classNotes !== null) {
          if (cacheCmp[1].classCode.localeCompare(classSummary.classCode) > 0) {
            classSummary.classCode = cacheCmp[1].classCode;
            if (cacheCmp[1].cache[cacheCmp[1].cache.length - 1]) {
              classSummary.classNotes = cacheCmp[1].classNotes;
            }
          }
        } else {
          classSummary.classCode = cacheCmp[1].classCode;
          classSummary.classNotes = cacheCmp[1].classNotes;
        }
        cacheCmp[1].cache.forEach((cacheElement) => {
          if (cacheElement.choices && cacheElement.choices) {
            const [...usingSplit] = String(cacheElement.choices).split('|');
            // eslint-disable-next-line prefer-destructuring
            classSummary.ruleRef = usingSplit[6];
          }
        });
      }
      const resultClass = this.summarizedRiskClassRules.resultingRiskClass;
      [
        classSummary.classCode,
        classSummary.classNotes,
        classSummary.classCodePfx,
        classSummary.classCodeSfx
      ] = [
        resultClass[0],
        resultClass[1],
        resultClass[0].split(' ')[0],
        resultClass[0].split(' ')[2]
          ? `${resultClass[0].split(' ')[1]} ${resultClass[0].split(' ')[2]}`
          : resultClass[0].split(' ')[1]
      ];
      this.kitClassSummary = classSummary;
    },
    summarizeClassInfoKit() {
      const classSummary = {
        classCode: null,
        classNotes: null,
        classCodePfx: null,
        classCodeSfx: null
      };
      const entryArr = [...this.prodClassCriteria.workflowResponseMap.entries()];
      for (let i = 0; i < entryArr.length; i += 1) {
        const cacheCmp = entryArr[i];
        if (classSummary.classCode !== null && classSummary.classNotes !== null) {
          if (cacheCmp[1].classCode.localeCompare(classSummary.classCode) > 0) {
            classSummary.classCode = cacheCmp[1].classCode;
            if (cacheCmp[1].cache[cacheCmp[1].cache.length - 1]) {
              classSummary.classNotes = cacheCmp[1].classNotes;
            }
          }
        } else {
          classSummary.classCode = cacheCmp[1].classCode;
          classSummary.classNotes = cacheCmp[1].classNotes;
        }
      }
      [classSummary.classCodePfx, classSummary.classCodeSfx] = [
        classSummary.classCode.split(' ')[0],
        classSummary.classCode.split(' ')[1]
      ];
      this.kitClassSummary = classSummary;
    },
    async validateFeatures() {
      this.loaderStatus = true;
      this.permissions = [];
      const servicesList = ['PRODUCT_CLASSIFICATION'];
      const modulesList = ['CLASSIFICATION'];
      this.permissions = await this.permissionsList(servicesList, modulesList);
      this.loaderStatus = false;
    },
    async initializePage() {
      await this.performPaymentCheck();
      await this.getAddonDetails();
      this.regPathwayPlanRouteMap.set(
        PROD_CLASS_RATIONALE_PLAN_ID,
        'ProductClassificationRationaleLanding'
      );
      this.regPathwayPlanRouteMap.set(8, '/layout/regulatory-pathway');
      this.regPathwayPlanRouteMap.set(11, '/layout/prodclassification-home');
    },
    async performPaymentCheck() {
      this.addedPlans = await getSubscribedPlans(this.account_id);
    },
    /**
     * If returns true then show Market place page to let user buy service
     */
    checkSubscriptionStatusForPlan(planId) {
      let showPSMPage = true;
      for (let iter = 0; iter < this.addedPlans.length; iter += 1) {
        if (this.addedPlans[iter].id === planId) {
          showPSMPage = false;
          break;
        }
      }
      return showPSMPage;
    },
    async loadConfig() {
      this.pageConfig = await getProdClassConfig();
    },
    getClassRuleRef() {
      const summarizedObj = {
        applicableRules: [],
        resultingRiskClass: [],
        highestClassRules: []
      };
      this.prodClassCriteria.interimClassDataArray.forEach((intrimDataIns) => {
        if (intrimDataIns) {
          if (
            this.prodClassCriteria.compositeArrayWrapper.classCode === intrimDataIns.int_class &&
            !summarizedObj.highestClassRules.includes(intrimDataIns.int_class_rule)
          ) {
            summarizedObj.highestClassRules.push(intrimDataIns.int_class_rule);
          }
        }
      });
      summarizedObj.highestClassRules.sort((a, b) => b - a);
      // this.prodClassCriteria.compositeArrayWrapper.classRuleRef = summarizedObj.highestClassRules[0];
      return summarizedObj.highestClassRules[0] ? summarizedObj.highestClassRules[0] : '1';
    },
    getClassRuleRefKit() {
      const summarizedObj = {
        applicableRules: [],
        resultingRiskClass: [],
        highestClassRules: []
      };
      this.prodClassCriteria.interimClassDataArray.forEach((intrimDataIns) => {
        if (intrimDataIns) {
          if (
            this.prodClassCriteria.compositeArrayWrapper.classCode === intrimDataIns.int_class &&
            !summarizedObj.highestClassRules.includes(intrimDataIns.int_class_rule)
          ) {
            summarizedObj.highestClassRules.push(intrimDataIns.int_class_rule);
          }
        }
      });
      summarizedObj.highestClassRules.sort((a, b) => b - a);
      // this.prodClassCriteria.compositeArrayWrapper.classRuleRef = summarizedObj.highestClassRules[0];
      return summarizedObj.highestClassRules[0] ? summarizedObj.highestClassRules[0] : '1';
    },

    navProdClassDashboard() {
      this.loaderStatus = true;
      this.$router.push('/layout/prodclassification');
      this.loaderStatus = false;
    },
    handleChange() {},
    findIfAnyReportsPending() {
      let checkFlag = false;
      if (prodClassData.rationalReportRequests) {
        const dataFoundArr = prodClassData.rationalReportRequests.filter(
          (element) => element.userId === this.userId
        );
        checkFlag = dataFoundArr && dataFoundArr.length > 0;
      }
      return checkFlag;
    },
    /**
     * A delegae from another method
     * Performs various subtasks
     * 1) Performs terminating check
     */
    async selectedOptionsWatchUtil(selOptvalue) {
      const splOverRideFlag =
        this.prodClassCriteria.country === 'EU MDD' ||
        this.prodClassCriteria.country === 'EU MDR' ||
        this.prodClassCriteria.country === 'Australia' ||
        this.prodClassCriteria.country === 'New Zealand';
      if (selOptvalue) {
        this.validationMsg = '';
        const levelVal = this.valAtIndex(selOptvalue, 2);
        let levelInt;
        if (levelVal) {
          levelInt = levelVal.substring(0, levelVal.indexOf('-'));
          this.searchCriteriaMap.set(levelInt, selOptvalue);
        }
        this.levelArrayMap.set(levelInt, levelVal);
        const levelArray = this.extractLevelArrayDataAsArray(this.levelArrayMap);

        this.ruleSearchQuery.class_node_request.vital_characteristic = this.valAtIndex(
          selOptvalue,
          0
        );
        if (
          this.prodClassCriteria.country === EU_IVDR &&
          this.ivdrTotalComponents &&
          this.ivdrTotalComponents > 1
        ) {
          this.ruleSearchQuery.class_node_request.multi_device = true;
        }
        this.ruleSearchQuery.class_node_request.level = levelVal;
        this.ruleSearchQuery.steps = levelArray;
        this.manageInterimClassMap(selOptvalue.split('|'));
        const terminatingClassCheck = await this.performTerminatingCheck(selOptvalue, levelArray);

        const terminatingNoClassI =
          this.effectiveHighestRiskClass() !== CLASSI &&
          this.valAtIndex(selOptvalue, 3) &&
          this.valAtIndex(selOptvalue, 4) &&
          this.valAtIndex(selOptvalue, 3).startsWith('Class');
        const terminatingClassI =
          this.effectiveHighestRiskClass() === CLASSI &&
          this.valAtIndex(selOptvalue, 3) &&
          this.valAtIndex(selOptvalue, 4) &&
          this.valAtIndex(selOptvalue, 3).startsWith('Class I');
        const terminatingConditionalNoClassI =
          terminatingClassCheck.terminating === true && this.effectiveHighestRiskClass() !== CLASSI;
        const terminatingConditionalClassI =
          terminatingClassCheck.terminating === true && this.effectiveHighestRiskClass() === CLASSI;

        const intClasValuesArr = [...this.prodClassCriteria.interimClassMap.values()];
        const interimClassObj = intClasValuesArr[intClasValuesArr.length - 1];

        if (terminatingNoClassI === true && terminatingClassCheck.terminating === false) {
          this.prodClassCriteria.compositeArrayWrapper.classFoundFlag = true;
          this.prodClassCriteria.compositeArrayWrapper.classNotes = this.valAtIndex(selOptvalue, 4);
          this.prodClassCriteria.compositeArrayWrapper.classCode = this.valAtIndex(selOptvalue, 3);
        } else if (terminatingConditionalNoClassI === true) {
          const filteredInterimClasValuesArr = intClasValuesArr.filter(
            (interimClassArrayVal) => interimClassArrayVal.int_class !== ''
          );
          filteredInterimClasValuesArr.sort(this.compareClassObjects);
          this.prodClassCriteria.compositeArrayWrapper.classFoundFlag =
            terminatingClassCheck.class_found;
          this.prodClassCriteria.compositeArrayWrapper.classNotes =
            filteredInterimClasValuesArr[filteredInterimClasValuesArr.length - 1].class_notes;
          this.prodClassCriteria.compositeArrayWrapper.classCode =
            filteredInterimClasValuesArr[filteredInterimClasValuesArr.length - 1].int_class;
          this.prodClassCriteria.compositeArrayWrapper.classRuleRef =
            filteredInterimClasValuesArr[filteredInterimClasValuesArr.length - 1].int_class_rule;
        } else if (
          (terminatingClassI === true && terminatingClassCheck.terminating === false) ||
          terminatingConditionalClassI === true
        ) {
          const interimClassObjParent = intClasValuesArr[intClasValuesArr.length - 2];
          if (interimClassObj.class_override != null && interimClassObj.class_override.length > 0) {
            this.prodClassCriteria.compositeArrayWrapper.classFoundFlag = false;
          } else if (interimClassObjParent.int_class === interimClassObj.int_class) {
            this.prodClassCriteria.compositeArrayWrapper.classFoundFlag = true;
          }
          this.prodClassCriteria.compositeArrayWrapper.classNotes =
            terminatingClassCheck.class_notes;
          this.prodClassCriteria.compositeArrayWrapper.classCode = terminatingClassCheck.class_code;
          if (!splOverRideFlag) {
            this.prodClassCriteria.compositeArrayWrapper.classFoundFlag = true;
          }
        } else if (
          interimClassObj.int_class !== '' &&
          interimClassObj.int_class.length > 0 &&
          this.valAtIndex(selOptvalue, 3) !== null &&
          this.valAtIndex(selOptvalue, 3).length > 0 &&
          this.valAtIndex(selOptvalue, 3) !== 'null'
        ) {
          this.prodClassCriteria.compositeArrayWrapper.classFoundFlag = true;
        } else {
          this.terminating = false;
          this.prodClassCriteria.compositeArrayWrapper.classFoundFlag = false;
        }
        this.optionsFlag = true;
      } else {
        this.form_validation_messages.work_flow.displayError = false;
        this.optionsFlag = false;
      }
      this.levelArrayVals();
    },
    compareClassObjects(classE1, classE2) {
      const classA = classE1.int_class;
      const classB = classE2.int_class;
      const ruleRefA = classE1.int_class_rule;
      const ruleRefB = classE2.int_class_rule;
      let comparison = 0;
      if (classA > classB) {
        comparison = 1;
      } else if (classA < classB) {
        comparison = -1;
      } else if (classA === classB) {
        if (ruleRefA > ruleRefB) {
          comparison = 1;
        } else if (ruleRefA < ruleRefB) {
          comparison = -1;
        }
      }
      return comparison;
    },
    openEmailPopup() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'Rationale Report',
        eventName: 'Open popup'
      });
      $('#modal_email').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    payForService() {
      this.$router.push('/layout/market-place/add-service/7');
    },
    /**
     * Checks access for PLAN ID 9 - Rationale Report and if not redirected then open Rationale report Page
     */
    checkMarketPlaceWrapperForRationaleReport() {
      if (this.checkSubscriptionStatusForPlan(PROD_CLASS_RATIONALE_PLAN_ID)) {
        this.$router.push({
          path: '/layout/market-place/service/6',
          params: { serviceId: 6, serviceIdsToDisplay: [7, 9, 10] }
        });
      }
      this.checkAvailableCapacityAndRedirectToMPlace();
      this.routeProductClassificationRationale();
    },
    checkMarketPlace(planId) {
      if (this.checkSubscriptionStatusForPlan(planId)) {
        this.$router.push({ path: '/layout/market-place/service/7' });
      } else {
        this.$router.push({
          path: this.regPathwayPlanRouteMap.get(planId),
          params: {
            searchCriteria: this.prodClassCriteria,
            accountId: this.account_id,
            userId: this.userId
          }
        });
      }
    },
    routeProductClassificationRationale() {
      const classWorkFlowData = {
        market: this.prodClassCriteria.country,
        med_device_type: this.medical_device_type,
        product_name: this.prodClassCriteria.device_name,
        user_id: this.userId,
        account_id: this.account_id,
        class_code: this.kitClassSummary.classCode,
        class_notes: this.kitClassSummary.classNotes,
        rule_ref: this.summarizedRiskRules.highestClassRules[0]
      };
      this.prodClassCriteria.compositeArrayWrapper.classCode = classWorkFlowData.class_code;
      [this.prodClassCriteria.compositeArrayWrapper.classRuleRef] =
        this.summarizedRiskRules.highestClassRules;
      const params = {
        searchCriteria: this.prodClassCriteria,
        accountId: this.account_id,
        userId: this.userId,
        sasToken: this.sasToken,
        ruleId: classWorkFlowData.rule_ref
      };
      if (this.prodClassCriteria.country === 'EU MDR') {
        this.$router.push({ name: 'ProductClassificationRationale', params });
      } else {
        this.$router.push({ name: 'ProductClassificationRationaleIVDR', params });
      }
    },
    downloadRationaleReportNew() {
      this.$router.push('/layout/download-rational-report');
    },
    /*
    Method to process data when a multi select is made.
    For multi select backend rules have matching conditions based on level values like '1-1,1-5' etc.
    */
    computeLevel(currentLevelWithSuffix) {
      let levelValArr = [];
      let currentLevel = null;
      if (currentLevelWithSuffix) {
        // eslint-disable-next-line prefer-destructuring
        currentLevel = currentLevelWithSuffix.split('-')[0];
      }
      const entryArr = [...this.levelArrayMap.entries()];
      for (let i = 0; i < entryArr.length; i += 1) {
        const elem = entryArr[i];
        if (Array.isArray(elem[1])) {
          const sortedLvlArr = elem[1].sort();
          // eslint-disable-next-line no-loop-func
          sortedLvlArr.forEach((elemNew) => {
            if (currentLevel && elemNew.split('-')[0] === currentLevel) {
              levelValArr.push(elemNew);
            }
          });
        } else {
          levelValArr.push(elem[1]);
        }
      }
      this.prodClassCriteria.levelArray = levelValArr;
      levelValArr = levelValArr.filter(
        (element) =>
          element &&
          element.length > 0 &&
          element.substring(0, 2) !== LEVEL_ARR[0] &&
          element.substring(0, 2) !== LEVEL_ARR[1] &&
          currentLevel === element.split('-')[0]
      );
      levelValArr = levelValArr.sort((a, b) => {
        const x = parseInt(a.substring(a.indexOf('-') + 1), 10);
        const y = parseInt(b.substring(b.indexOf('-') + 1), 10);
        if (x < y) {
          return -1;
        }
        if (x > y) {
          return 1;
        }
        return 0;
      });
      return levelValArr;
    },
    levelArrayVals() {
      let levelValArr = [];
      const entryArr = [...this.levelArrayMap.entries()];
      for (let i = 0; i < entryArr.length; i += 1) {
        const elem = entryArr[i];
        if (Array.isArray(elem[1])) {
          const sortedLvlArr = elem[1].sort();
          // eslint-disable-next-line no-loop-func
          sortedLvlArr.forEach((elemNew) => {
            levelValArr.push(elemNew);
          });
        } else {
          levelValArr.push(elem[1]);
        }
      }
      this.prodClassCriteria.levelArray = levelValArr;
      levelValArr = levelValArr.filter(
        (element) =>
          element &&
          element.length > 0 &&
          element.substring(0, 2) !== LEVEL_ARR[0] &&
          element.substring(0, 2) !== LEVEL_ARR[1]
      );
      return levelValArr;
    },
    // Method to simply get an array of values that are multi select. [To get all multi select values]
    computeLevelFromArray() {
      let levelValArr = [];
      const entryArr = [...this.levelArrayMap.entries()];
      levelValArr = entryArr.filter((currEle) => Array.isArray(currEle));
      return levelValArr;
    },
    async performTerminatingCheck(selOptvalue, levelArray) {
      const classMetaData = {
        class_code: '',
        class_notes: '',
        class_found: false,
        terminating: false
      };
      const ruleQueryForTerminatingCheck = this.customQueryForNode(
        selOptvalue.split('|'),
        true,
        true,
        levelArray
      );
      const response = await getClassificationsUsingAttrWrapper(ruleQueryForTerminatingCheck);
      const respData = response.data.data;
      if (
        respData.terminating &&
        respData.terminating === true &&
        respData.children &&
        respData.children.length === 0
      ) {
        classMetaData.class_code = respData.classification_code;
        classMetaData.class_notes = respData.classification_notes;
        if (respData.classification_code && respData.classification_code.startsWith('Class')) {
          classMetaData.terminating = true;
          classMetaData.class_found = true;
        } else {
          classMetaData.terminating = false;
          classMetaData.class_found = false;
        }
      } else {
        classMetaData.class_code = '';
        classMetaData.class_notes = '';
        classMetaData.terminating = false;
        classMetaData.class_found = false;
      }
      return classMetaData;
    },
    levelArrayArranged() {
      const valuesSelected = [...this.levelArrayMap.values()];
      return valuesSelected;
    },
    valAtIndex(pipeSeparatedStr, index) {
      return pipeSeparatedStr ? pipeSeparatedStr.split('|')[index] : '';
    },
    /**
     * Uses logic that class with highest rules are picked
     */
    effectiveHighestRiskClass() {
      const summarizedObj = {
        applicableRules: [],
        resultingRiskClass: ''
      };
      let doOverRide = false;
      this.prodClassCriteria.interimClassDataArray = [
        ...this.prodClassCriteria.interimClassMap.values()
      ];
      this.prodClassCriteria.interimClassDataArray.forEach((intrimDataIns) => {
        if (intrimDataIns && intrimDataIns.int_class) {
          // Process differently if attribute class_override is 'Y' vs 'N' or null
          if (intrimDataIns.class_override === 'Y') {
            doOverRide = true;
          } else if (!summarizedObj.resultingRiskClass) {
            summarizedObj.resultingRiskClass = intrimDataIns.int_class;
          } else if (intrimDataIns.int_class.localeCompare(summarizedObj.resultingRiskClass) > 0) {
            summarizedObj.resultingRiskClass = intrimDataIns.int_class;
          }
        }
      });
      // This check required to do a proper override(blood bags.even if IIb or III blood bags are always IIa)
      if (doOverRide === true) {
        if (
          this.prodClassCriteria.interimClassDataArray.filter(
            (element) => element.class_override === 'Y'
          )
        ) {
          summarizedObj.resultingRiskClass = this.prodClassCriteria.interimClassDataArray.filter(
            (element) => element.class_override === 'Y'
          )[0].int_class;
        }
      }
      return summarizedObj.resultingRiskClass;
    },

    /**
     * Utility reset all function
     */
    async startOver() {
      this.prodClassTrialAccessAllowed = await getProdClassUsageFlag(
        JSON.parse(localStorage.getItem('userData')).account_id
      );
      if (this.prodClassTrialAccessAllowed === false) {
        $('#pcAccessPopupModal').modal({
          backdrop: 'static',
          keyboard: false
        });
      } else {
        this.resetAll();
      }
    },
    /**
     * Utility to apply a filter on countries drop down data.
     */
    filterCountries() {
      let cntryArr = [];
      for (let loopCtr = 0; loopCtr < deviceTypeArray.length; ) {
        if (deviceTypeArray[loopCtr].dev_typ === this.medical_device_type) {
          cntryArr = deviceTypeArray[loopCtr].countries;
          break;
        }
        loopCtr += 1;
      }
      this.prodClassCriteria.filteredCountries = cntryArr.filter((item) => item.display === true);
      this.prodClassCriteria.country = this.prodClassCriteria.filteredCountries[0].country_value;
      this.resetAll();
    },
    responseChanged(id) {
      this.ruleSearchQuery.class_node_request.vital_characteristic = this.valAtIndex(id, 0);
      this.ruleSearchQuery.class_node_request.level = this.valAtIndex(id, 2);
      this.ruleSearchQuery.steps = this.levelArrayVals();
    },
    /**
     * This is invoked when checkboxes are checked.
     */
    choicesChanged() {
      this.validationMsg = '';
      // Check here in workflowResponseCache array and if a match is found then update element 'choices' in the array with selected choices.
      for (let idx = 0; idx < this.prodClassCriteria.workflowResponseCache.length; idx += 1) {
        const responChoicesObj = this.prodClassCriteria.workflowResponseCache[idx];
        if (
          this.prodClassCriteria.compositeArrayWrapper.dataArray[0].vital_characteristic ===
          responChoicesObj.response_data.vital_characteristic
        ) {
          responChoicesObj.choices = this.prodClassCriteria.selectedChoices;
        }
      }
      // If first tab of wizard.i.e. on Multi select page
      // Before control enteres here clear all the elements that has 1- as begining value in level
      const levelArrlength = this.prodClassCriteria.levelArray.length;
      for (let lvlArrIdx = 0; lvlArrIdx < levelArrlength; lvlArrIdx += 1) {
        if (
          this.prodClassCriteria.levelArray[lvlArrIdx] &&
          this.prodClassCriteria.levelArray[lvlArrIdx].substring(0, 2) === '1-'
        ) {
          this.prodClassCriteria.levelArray.splice(lvlArrIdx, 1);
        }
      }
      this.prodClassCriteria.levelArray.length = 0;
      this.prodClassCriteria.selectedChoices.forEach((element) => {
        this.prodClassCriteria.levelArray.push(element.split('|')[2]);
      });
      // To apply conditional disabling of mutually exclusive choices for Q1. (At any point of timne only No or any combination of yeses should be selected)
      this.fireValidations();
    },
    /**
     * Resets validation message and also massages searchCriteriaArray to hold workflow data.
     * Level, Questions,Responses
     */
    optionPicked() {
      this.validationMsg = '';
      for (let idx = 0; idx < this.prodClassCriteria.workflowResponseCache.length; idx += 1) {
        const responChoicesObj = this.prodClassCriteria.workflowResponseCache[idx];
        if (
          this.prodClassCriteria.compositeArrayWrapper.dataArray[0].vital_characteristic ===
          responChoicesObj.response_data.vital_characteristic
        ) {
          responChoicesObj.choices = this.prodClassCriteria.selectedOptions;
        }
      }
    },
    sortedLevelArray() {
      const sortedLevelAray = this.prodClassCriteria.levelArray;
      return sortedLevelAray;
    },
    cleanMultiSel() {
      if (
        (this.arrayLengths.wf_resp_arr === 1 &&
          this.valAtIndex(this.prodClassCriteria.selectedOptions, 0) === 'No' &&
          this.navDir === NAV_DIR_FORWARD &&
          JSON.stringify(['43-2']) === JSON.stringify(this.sortedLevelArray())) ||
        (this.arrayLengths.wf_resp_arr === 2 &&
          this.valAtIndex(this.prodClassCriteria.selectedOptions, 0) === 'No' &&
          this.navDir === NAV_DIR_FORWARD &&
          JSON.stringify(['43-1', '44-2']) === JSON.stringify(this.sortedLevelArray()))
      ) {
        this.prodClassCriteria.selectedChoices = [];
        this.choiceFlag = false;
        this.disabledChoices = [];
      }
    },
    /**
     * Next clicked
     */
    next() {
      this.navDir = NAV_DIR_FORWARD;
      this.cleanMultiSel();
      if (this.prodClassCriteria.current_slide_number === 0) {
        this.processNext();
        this.prodClassCriteria.current_slide_number += 1;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'Product classification tracking',
          product_classification_stage:
            this.cases[this.prodClassCriteria.current_slide_number].title
        });
      } else if (this.prodClassCriteria.compositeArrayWrapper.classFoundFlag === true) {
        this.populateWorkflowCacheKitFlow();
        this.ivdrCurrCtr += 1;
        this.prodClassCriteria.current_slide_number += 1;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'Product classification tracking',
          product_classification_stage:
            this.cases[this.prodClassCriteria.current_slide_number].title
        });
      } else if (
        this.prodClassCriteria.current_slide_number === 1 &&
        this.prodClassCriteria.country !== EU_IVDR
      ) {
        this.processNext();
        this.populateWorkflowCacheKitFlow();
      } else if (
        this.prodClassCriteria.current_slide_number === 1 &&
        this.prodClassCriteria.country === EU_IVDR
      ) {
        this.processNext();
        this.populateWorkflowCacheKitFlow();
      }
    },
    populateWorkflowCacheKitFlow() {
      const workflowResponseCacheClone = [...this.prodClassCriteria.workflowResponseCache];
      const searchCriteriaMapClone = [...this.searchCriteriaMap];
      const headerComp = {
        name: this.prodClassCriteria.componentName[this.ivdrCurrCtr],
        classCode: this.prodClassCriteria.compositeArrayWrapper.classCode,
        classNotes: this.prodClassCriteria.compositeArrayWrapper.classNotes,
        ruleRef: 0,
        cache: workflowResponseCacheClone
      };

      if (this.searchCriteriaMapKit && this.prodClassCriteria.componentName[this.ivdrCurrCtr]) {
        this.searchCriteriaMapKit.set(
          this.prodClassCriteria.componentName[this.ivdrCurrCtr],
          searchCriteriaMapClone
        );
      }
      if (this.prodClassCriteria.workflowResponseMap) {
        this.prodClassCriteria.workflowResponseMap.set(this.ivdrCurrCtr, headerComp);
      }
      const lvlArrayClone = [...this.prodClassCriteria.levelArray];
      if (this.prodClassCriteria.mapLevelArray) {
        this.prodClassCriteria.mapLevelArray.set(this.ivdrCurrCtr, lvlArrayClone);
      }
    },
    /**
     *
     */
    isSpecialClassOverrideApplicable() {
      const clsInfo = this.extractClassInfo(
        this.prodClassCriteria.selectedOptions.split('|')
      ).class_found;
      const splClsCheck =
        this.highestClassOverrideFlag === true &&
        this.effectiveHighestRiskClass() === CLASSI &&
        clsInfo === true;
      return splClsCheck;
    },
    processNext() {
      this.searchFollowupRules(this.ruleSearchQuery);
    },
    /**
     * Utility reset all
     */
    resetAll() {
      this.resetCompArray();
      this.validationMsg = '';
      this.prodClassCriteria.interimClassDataArray = [];
      this.prodClassCriteria.selectedChoices = [];
      this.prodClassCriteria.selectedOptions = '';
      this.prodClassCriteria.searchCriteriaArray = [];
      this.prodClassCriteria.workflowResponseCache = [];
      this.prodClassCriteria.workflowResponseMap.clear();
      this.productClassData = [];
      this.compositeArray = [];
      this.prodClassCriteria.current_slide_number = 0;
      this.prodClassCriteria.classificationFinalized = false;
      this.disabledChoices = [];
      this.prodClassCriteria.ruleRefArray = [];
      this.levelArrayMap.clear();
      this.searchCriteriaMap.clear();
      this.searchCriteriaMapKit.clear();
      this.prodClassCriteria.interimClassMap.clear();
      this.resetRuleSearchQuery();
      this.prodClassCriteria.componentName = [];
      this.ivdrCurrCtr = 0;
      this.ivdrTotalComponents = 2;
      this.ivdrKitFlow = false;
      this.currLevel = [];
    },
    resetChoices() {
      this.prodClassCriteria.selectedChoices = [];
    },
    /**
     *
     */
    resetRuleSearchQuery() {
      this.ruleSearchQuery = {
        class_node_request: {
          market: this.prodClassCriteria.country,
          vital_characteristic: null,
          characteristic_type: 'Option',
          level: null
        },
        steps: []
      };
    },
    /**
     * Resets object prodClassCriteria.compositeArrayWrapper for further reuse.
     */
    resetCompArray() {
      this.prodClassCriteria.selectedChoices = [];
      this.prodClassCriteria.compositeArrayWrapper = {
        classFoundFlag: false,
        classNotes: '',
        classCode: '',
        dataArray: []
      };
      this.prodClassCriteria.levelArray = [];
    },
    showCriteriaForCountry() {
      const searchCriteriaArr = this.prodClassCriteria.country;
      let criteriaArr = [];
      if (searchCriteriaArr) {
        for (let i = 0; i < searchCriteriaArr.length; ) {
          if (this.prodClassCriteria.country === searchCriteriaArr[i].countryName) {
            criteriaArr = searchCriteriaArr[i].criteria;
          }
          i += 1;
        }
      }
      this.checkOptions = criteriaArr;
      this.ruleSearchQuery.class_node_request.market = this.prodClassCriteria.country;
      if (this.prodClassCriteria.country === 'UK') {
        $('#ukDisclaimerModal').modal({
          backdrop: 'static',
          keyboard: false
        });
      }
    },
    /**
     * Utility function to set Clssification attributes
     */
    setClassInfo(clsCode, clsNotes, flag) {
      this.prodClassCriteria.compositeArrayWrapper.classCode = clsCode;
      this.prodClassCriteria.compositeArrayWrapper.classNotes = clsNotes;
      this.prodClassCriteria.compositeArrayWrapper.classFoundFlag = flag;
    },
    /**
     *
     */
    setMultiSelect(compositeArray) {
      // compositeArray is an array (of single element) with another array of children
      let multSelect;
      compositeArray[0].children.forEach((child) => {
        if (child && child.multi_select === 'Y') {
          multSelect = true;
        }
      });
      multSelect = compositeArray[0].multi_select === 'Y';
      this.multi_select = multSelect;
      if (multSelect) {
        this.choiceFlag = false;
      }
    },
    /**
     * This will process JSON data to create an array where each element has another array defined
     * as child of parent element.
     */
    processArrayToGetHierarchicalData(arraySameLevelData) {
      let ruleDataTitleElement = [];
      let ruleDataOptionsElements = [];
      ruleDataTitleElement = arraySameLevelData.filter(
        (element) => element.characteristic_type === 'Title'
      );
      ruleDataOptionsElements = arraySameLevelData.filter(
        (element) =>
          element.characteristic_type === 'Option' ||
          element.characteristic_type === 'NumberEntry' ||
          element.characteristic_type === 'Response'
      );
      if (ruleDataOptionsElements && ruleDataOptionsElements.length === 0) {
        ruleDataOptionsElements = arraySameLevelData.filter(
          (element) => element.characteristic_type === 'NumberEntry'
        );
      }

      if (ruleDataTitleElement && ruleDataTitleElement[0]) {
        ruleDataTitleElement[0].children = ruleDataOptionsElements;
      }
      this.currLevel.push(ruleDataTitleElement[0].level);
      return ruleDataTitleElement;
    },
    async getCountries() {
      this.countriesData = countryData;
      if (this.countriesData.countries) {
        if (this.countriesData.default_country) {
          this.prodClassCriteria.country = this.countriesData.default_country.country_name;
        } else {
          this.prodClassCriteria.country = this.countriesData.countries[0].country_name;
        }
      }
    },
    /**
     * This is called for each click of Next until a class is Found. (Indirectly from processNextClicked)
     */
    async searchFollowupRules(requestPayload) {
      const response = await getClassificationsUsingAttrWrapper(requestPayload);
      this.productClassData = response.data.data;
      if (
        this.productClassData &&
        this.productClassData.children &&
        this.productClassData.children.length > 0
      ) {
        this.compositeArray = this.processArrayToGetHierarchicalData(
          this.productClassData.children
        );
        this.setMultiSelect(this.compositeArray);
        this.prodClassCriteria.compositeArrayWrapper.dataArray = this.compositeArray;

        if (
          !this.prodClassCriteria.workflowResponseCache.includes({
            response_data: this.compositeArray[0],
            choices: ''
          })
        ) {
          this.prodClassCriteria.workflowResponseCache.push({
            response_data: this.compositeArray[0],
            choices: ''
          });
        } else {
          this.prodClassCriteria.workflowResponseCache.pop();
        }
      } else {
        this.validationMsg = 'Search Broken-Please refine your search';
      }
      this.prodClassCriteria.selectedOptions = '';
    },

    /**
     *
     */
    finalizeClassification() {
      const ruleRef = this.getClassRuleRef();
      this.prodClassCriteria.compositeArrayWrapper.classRuleRef = ruleRef;
      this.prodClassCriteria.classificationFinalized = true;
      this.prodClassCriteria.current_slide_number += 1;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'Product classification tracking',
        product_classification_stage: this.cases[this.prodClassCriteria.current_slide_number].title
      });
      this.summarizeClassInfo();
      this.prepareWorkflowData();
    },
    /**
     * ${}
     * This is executed when more kit components are needed to be classfied.
     */
    continueKitComponent() {
      // No need to pop anything from workflowResponseCache
      const noOfElementsToPop = this.prodClassCriteria.workflowResponseCache.length - 1;
      for (let idx = 1; idx < noOfElementsToPop; idx += 1) {
        this.prodClassCriteria.workflowResponseCache.pop();
        this.prodClassCriteria.levelArray.pop();
        // Delete elements from the back in the map that is keeping selected Queries.
        const keys = [...this.searchCriteriaMap.keys()];
        const lastKey = keys[keys.length - 1];
        this.searchCriteriaMap.delete(lastKey);
        this.levelArrayMap.delete(lastKey);
        this.prodClassCriteria.interimClassMap.delete(lastKey);
      }

      this.prodClassCriteria.compositeArrayWrapper.dataArray = [
        this.prodClassCriteria.workflowResponseCache[
          this.prodClassCriteria.workflowResponseCache.length - 1
        ].response_data
      ];
      const choicesObj =
        this.prodClassCriteria.workflowResponseCache[
          this.prodClassCriteria.workflowResponseCache.length - 1
        ].choices;
      this.prodClassCriteria.selectedOptions = choicesObj;
      this.prodClassCriteria.current_slide_number = 1;
      this.resetClassInfo();
    },
    finalizeClassificationKit() {
      const ruleRef = this.getClassRuleRefKit();
      this.prodClassCriteria.compositeArrayWrapper.classRuleRef = ruleRef;
      this.prodClassCriteria.classificationFinalized = true;
      this.prodClassCriteria.current_slide_number += 1;
      this.summarizeClassInfoKit();
      this.prepareWorkflowDataKit();
    },
    resetErrorMsg() {
      this.form_validation_messages.device_name.displayError = false;
      this.form_validation_messages.work_flow.displayError = false;
    },
    async getAddonDetails() {
      this.addonDetails = await getAddonDetails(this.account_id);
      const addonObjectPaidAddOn = this.addonDetails.filter((addOnObj) => addOnObj.id === 5);
      // eslint-disable-next-line prefer-destructuring
      this.classificationAddonObj = addonObjectPaidAddOn[0];
      if (this.classificationAddonObj) {
        this.max_classification_allowed = this.classificationAddonObj.total_limit;
      }
      if (
        addonObjectPaidAddOn[0] &&
        addonObjectPaidAddOn[0].total_limit > addonObjectPaidAddOn[0].current_utilization
      ) {
        this.classificationAddonAvailable = true;
      } else {
        this.classificationAddonAvailable = false;
      }
    },
    async checkAvailableCapacityAndRedirectToMPlace() {
      const availableCapacityForPlan = await getAvailableCapacity(
        JSON.parse(localStorage.getItem('userData')).account_id,
        6
      );
      if (availableCapacityForPlan <= 0) {
        this.redirectPSM();
      }
    },
    redirectPSM() {
      const params = { serviceId: 6, serviceIdsToDisplay: [7, 9, 10], defaultSelectedService: 9 };
      this.$router.push({ name: 'addService', params });
    },
    /**
     * Validate form for basic data.
     */
    validateForm() {
      const allChecksPassed = true;
      if (allChecksPassed) {
        if (!this.prodClassCriteria.device_name) {
          this.form_validation_messages.device_name.displayError = true;
        } else {
          this.navDir = NAV_DIR_FORWARD;
          this.next();
        }
      }
    },
    downloadRationaleReport() {
      if (!this.prodClassCriteria.device_name) {
        this.form_validation_messages.device_name.displayError = true;
      } else {
        this.navDir = NAV_DIR_FORWARD;
        this.next();
      }
    },
    /**
     * Method gets called from Next action.
     * Performs checks whether user selected either of choices or options or not.
     */
    nextValidate() {
      if (
        this.prodClassCriteria.country !== 'Australia' &&
        this.prodClassCriteria.country !== 'New Zealand'
      ) {
        if (
          this.prodClassCriteria.compositeArrayWrapper.dataArray &&
          this.prodClassCriteria.compositeArrayWrapper.dataArray[0] &&
          this.prodClassCriteria.compositeArrayWrapper.dataArray[0].level !== '20-0' &&
          this.prodClassCriteria.country === EU_IVDR &&
          this.choiceFlag === false &&
          this.optionsFlag === false
        ) {
          this.validationMsg = `${SELECT_RESPONSE}`;
        } else if (
          this.prodClassCriteria.compositeArrayWrapper.dataArray &&
          this.prodClassCriteria.compositeArrayWrapper.dataArray[0] &&
          this.prodClassCriteria.compositeArrayWrapper.dataArray[0].level === '20-0' &&
          this.prodClassCriteria.country === EU_IVDR &&
          this.choiceFlag === false &&
          this.optionsFlag === false &&
          !this.prodClassCriteria.componentName[this.ivdrCurrCtr]
        ) {
          this.form_validation_messages.ivdr_component_name.displayError = true;
        } else if (
          this.choiceFlag === false &&
          this.optionsFlag === false &&
          this.prodClassCriteria.country !== EU_IVDR
        ) {
          this.validationMsg = `${SELECT_RESPONSE}`;
        } else if (
          this.choiceFlag === true &&
          this.optionsFlag === false &&
          this.arrayLengths.wf_resp_arr > 1
        ) {
          this.validationMsg = `${SELECT_RESPONSE}`;
        } else if (
          this.choiceFlag === true &&
          this.optionsFlag === true &&
          this.arrayLengths.wf_resp_arr > 1
        ) {
          this.next();
        } else this.next();
      } else if (
        this.prodClassCriteria.country === 'Australia' ||
        this.prodClassCriteria.country === 'New Zealand'
      ) {
        if (!this.isSelectionMade()) {
          this.validationMsg = `${SELECT_RESPONSE}`;
        } else {
          this.multi_select = false;
          this.optionsFlag = false;
          this.choiceFlag = false;
          this.next();
          this.navDir = NAV_DIR_FORWARD;
        }
      }
    },
    /**
     * Uses optionsFlag (gets populated by radio select) and choiceFlag to decide if user made a selection
     */
    isSelectionMade() {
      return this.optionsFlag || this.choiceFlag;
    },
    /**
     * This is part of the payload object.
     * We are sending this and an array of all previous levels to rules Service for each call.
     */
    preparePayloadObjectFromSelectedOptions() {
      const valueArray = this.prodClassCriteria.selectedOptions.split('|');
      let payloadObjNext;
      if (this.arrayLengths.srch_cri_arr_len === 1) {
        let lowestOrderResponse = null;
        const levelArray = [];
        this.prodClassCriteria.selectedChoices.forEach((ele) => {
          levelArray.push(ele.split('|')[2]);
        });
        levelArray.sort();
        this.prodClassCriteria.selectedChoices.forEach((choice) => {
          if (choice.split('|')[2] === levelArray[0]) {
            lowestOrderResponse = choice;
          }
        });
        payloadObjNext = {
          market: this.prodClassCriteria.country,
          vital_characteristic: lowestOrderResponse.split('|')[0],
          characteristic_type: valueArray[1],
          level: levelArray.length <= 2 ? levelArray[0] : levelArray.join(',')
        };
      } else {
        payloadObjNext = {
          market: this.prodClassCriteria.country,
          vital_characteristic: valueArray[0] === '' ? null : valueArray[0],
          characteristic_type: valueArray[1],
          level: valueArray[2] === '' ? null : valueArray[2]
        };
      }
      return payloadObjNext;
    },
    preparePayloadObjectFromSelectedOptionsWithFlag(flag) {
      const valueArray = this.prodClassCriteria.selectedOptions.split('|');
      let payloadObjNext;
      if (this.arrayLengths.srch_cri_arr_len === 1) {
        let lowestOrderResponse = null;
        const levelArray = [];
        this.prodClassCriteria.selectedChoices.forEach((ele) => {
          levelArray.push(ele.split('|')[2]);
        });
        levelArray.sort();
        this.prodClassCriteria.selectedChoices.forEach((choice) => {
          if (choice.split('|')[2] === levelArray[0]) {
            lowestOrderResponse = choice;
          }
        });
        payloadObjNext = {
          market: this.prodClassCriteria.country,
          vital_characteristic: lowestOrderResponse.split('|')[0],
          characteristic_type: valueArray[1],
          level: levelArray.length <= 2 ? levelArray[0] : levelArray.join(','),
          highest_class_override: flag
        };
      } else {
        payloadObjNext = {
          market: this.prodClassCriteria.country,
          vital_characteristic: valueArray[0] === '' ? null : valueArray[0],
          characteristic_type: valueArray[1],
          level: valueArray[2] === '' ? null : valueArray[2],
          highest_class_override: flag
        };
      }
      return payloadObjNext;
    },
    /**
     *
     */
    getRequestPayloadForCheckingTerminating(valueArray, terminatingFlag, highestClassOverrideFlag) {
      const payloadObjNext = {
        market: this.prodClassCriteria.country,
        vital_characteristic: valueArray[0] === '' ? null : valueArray[0],
        characteristic_type: valueArray[1],
        level: valueArray[2] === '' ? null : valueArray[2],
        highest_class_override: highestClassOverrideFlag,
        previous_steps: this.prodClassCriteria.levelArray,
        terminating: terminatingFlag
      };
      return payloadObjNext;
    },
    /**
     *
     */
    customQueryForNode(valueArray, terminatingFlag, highestClassOverrideFlag, stepsValue) {
      const nodeQueryTerminating = {
        class_node_request: {
          market: this.prodClassCriteria.country,
          vital_characteristic: valueArray[0] === '' ? null : valueArray[0],
          characteristic_type: 'Option',
          level: valueArray[2] === '' ? null : valueArray[2],
          highest_class_override: highestClassOverrideFlag,
          terminating: terminatingFlag
        },
        steps: stepsValue
      };
      return nodeQueryTerminating;
    },
    /**
     *
    manageLevelArray(prodClsCrit, levelValue) {
      if (levelValue != null) {
        if (!prodClsCrit.levelArray.includes(levelValue)) prodClsCrit.levelArray.push(levelValue);
      }
    }, */
    /**
     * Manages a map of interim classes.
     */
    manageInterimClassMap(valueArray) {
      const levelVal = valueArray[2];
      const levelInt = levelVal.substring(0, levelVal.indexOf('-'));
      const intClasObj = {
        level: valueArray[2],
        int_class: valueArray[5],
        int_class_rule: valueArray[6],
        class_override: valueArray[9],
        class_notes: valueArray[4]
      };
      this.prodClassCriteria.interimClassMap.set(levelInt, intClasObj);
    },
    backWrapper() {
      if (this.prodClassCriteria.country === EU_IVDR) {
        this.backKit();
      } else if (this.prodClassCriteria.country !== EU_IVDR) {
        this.back();
      }
    },
    /**
     * This will work on data cached in this.prodClassCriteria.classificationFinalized array
     */
    back() {
      if (
        this.prodClassCriteria.current_slide_number === 1 &&
        this.prodClassCriteria.selectedChoices.length === 0 &&
        this.arrayLengths.wf_resp_arr === 1 &&
        this.prodClassCriteria.selectedChoices.length === 0
      ) {
        this.navDir = NAV_DIR_BACKWARD;
        // Only navigated to Questionnaire and no selection made
        this.resetAll();
      } else if (
        this.prodClassCriteria.current_slide_number === 1 &&
        this.prodClassCriteria.selectedChoices.length !== 0 &&
        this.arrayLengths.wf_resp_arr === 1
      ) {
        // Only navigated to Questionnaire and either one or more selections made
        this.resetAll();
        for (let idx = 0; idx < this.prodClassCriteria.levelArray.length; idx += 1) {
          this.prodClassCriteria.levelArray.pop();
        }
        this.navDir = NAV_DIR_BACKWARD;
      } else if (
        this.prodClassCriteria.current_slide_number === 1 &&
        this.arrayLengths.wf_resp_arr > 1
      ) {
        this.validationMsg = '';
        const showThisData =
          this.prodClassCriteria.workflowResponseCache[
            this.prodClassCriteria.workflowResponseCache.length - 2
          ].response_data;
        // While navigating back when we encounter a multi-select dataset or attribute "multi_select" is "Y" flag multi_select shoulb be set to true.
        this.multi_select = showThisData.multi_select === 'Y';
        // If country is 'Australia' make prodClassCriteria.selectedChoices empty

        this.prodClassCriteria.compositeArrayWrapper.dataArray = [showThisData];
        const choicesObj =
          this.prodClassCriteria.workflowResponseCache[
            this.prodClassCriteria.workflowResponseCache.length - 2
          ].choices;
        if (Array.isArray(choicesObj)) {
          this.prodClassCriteria.selectedChoices = [];
          this.prodClassCriteria.selectedChoices = choicesObj;
        } else {
          this.prodClassCriteria.selectedOptions = '';
          this.prodClassCriteria.selectedOptions = choicesObj;
        }
        const didUserSelectRadio = this.arrayLengths.wf_resp_arr === this.levelArrayMap.size;
        this.prodClassCriteria.workflowResponseCache.pop();
        if (didUserSelectRadio) {
          const keys = [...this.searchCriteriaMap.keys()];
          const lastKey = keys[keys.length - 1];
          this.searchCriteriaMap.delete(lastKey);
          this.levelArrayMap.delete(lastKey);
          this.prodClassCriteria.interimClassMap.delete(lastKey);
        }
        this.resetClassInfo();
        this.navDir = NAV_DIR_BACKWARD;
      } else if (this.prodClassCriteria.current_slide_number === 2) {
        // On Summary page and navigating back.
        const showThisData =
          this.prodClassCriteria.workflowResponseCache[
            this.prodClassCriteria.workflowResponseCache.length - 1
          ].response_data;
        this.prodClassCriteria.compositeArrayWrapper.dataArray = [showThisData];
        const choicesObj =
          this.prodClassCriteria.workflowResponseCache[
            this.prodClassCriteria.workflowResponseCache.length - 1
          ].choices;
        this.validationMsg = '';
        this.prodClassCriteria.interimClassDataArray.pop();
        this.prodClassCriteria.selectedOptions = '';
        this.prodClassCriteria.selectedOptions = choicesObj;
        this.prodClassCriteria.current_slide_number -= 1;
        this.navDir = NAV_DIR_BACKWARD;
      }
      this.currLevel.pop();
    },
    backKit() {
      if (
        this.prodClassCriteria.current_slide_number === 1 &&
        this.prodClassCriteria.selectedChoices.length === 0 &&
        this.arrayLengths.wf_resp_arr === 1 &&
        this.prodClassCriteria.selectedChoices.length === 0
      ) {
        this.navDir = NAV_DIR_BACKWARD;
        // Only navigated to Questionnaire and no selection made
        this.resetAll();
      } else if (
        this.prodClassCriteria.current_slide_number === 1 &&
        this.prodClassCriteria.selectedChoices.length !== 0 &&
        this.arrayLengths.wf_resp_arr === 1
      ) {
        // Only navigated to Questionnaire and either one or more selections made
        this.resetAll();
        for (let idx = 0; idx < this.prodClassCriteria.levelArray.length; idx += 1) {
          this.prodClassCriteria.levelArray.pop();
        }
        this.navDir = NAV_DIR_BACKWARD;
      } else if (
        this.prodClassCriteria.current_slide_number === 1 &&
        this.arrayLengths.wf_resp_arr > 1
      ) {
        this.validationMsg = '';
        const showThisData =
          this.prodClassCriteria.workflowResponseCache[
            this.prodClassCriteria.workflowResponseCache.length - 2
          ].response_data;
        // While navigating back when we encounter a multi-select dataset or attribute "multi_select" is "Y" flag multi_select shoulb be set to true.
        this.multi_select = showThisData.multi_select === 'Y';
        // If country is 'Australia' make prodClassCriteria.selectedChoices empty

        this.prodClassCriteria.compositeArrayWrapper.dataArray = [showThisData];
        const choicesObj =
          this.prodClassCriteria.workflowResponseCache[
            this.prodClassCriteria.workflowResponseCache.length - 2
          ].choices;

        this.prodClassCriteria.selectedOptions = '';
        this.prodClassCriteria.selectedOptions = choicesObj;

        const didUserSelectRadio = this.arrayLengths.wf_resp_arr === this.levelArrayMap.size;
        this.prodClassCriteria.workflowResponseCache.pop();
        if (didUserSelectRadio) {
          const keys = [...this.searchCriteriaMap.keys()];
          const lastKey = keys[keys.length - 1];
          this.searchCriteriaMap.delete(lastKey);
          this.levelArrayMap.delete(lastKey);
          this.prodClassCriteria.interimClassMap.delete(lastKey);
        }
        this.resetClassInfo();
        this.navDir = NAV_DIR_BACKWARD;
      } else if (this.prodClassCriteria.current_slide_number === 2) {
        // On Summary page and navigating back.
        const showThisData =
          this.prodClassCriteria.workflowResponseCache[
            this.prodClassCriteria.workflowResponseCache.length - 1
          ].response_data;
        this.prodClassCriteria.compositeArrayWrapper.dataArray = [showThisData];
        const choicesObj =
          this.prodClassCriteria.workflowResponseCache[
            this.prodClassCriteria.workflowResponseCache.length - 1
          ].choices;
        this.validationMsg = '';
        this.prodClassCriteria.interimClassDataArray.pop();
        this.prodClassCriteria.selectedOptions = '';
        this.prodClassCriteria.selectedOptions = choicesObj;
        this.prodClassCriteria.current_slide_number -= 1;
        this.navDir = NAV_DIR_BACKWARD;
        this.ivdrCurrCtr -= 1;
      }
    },
    /**
     * This will work on data cached in this.prodClassCriteria.classificationFinalized array
     */
    backClassic() {
      if (
        this.prodClassCriteria.current_slide_number === 1 &&
        this.prodClassCriteria.selectedChoices.length === 0 &&
        this.arrayLengths.wf_resp_arr === 1
      ) {
        this.navDir = NAV_DIR_BACKWARD;
        // Only navigated to Questionnaire and no selection made
        this.resetAll();
      } else if (
        this.prodClassCriteria.current_slide_number === 1 &&
        this.prodClassCriteria.selectedChoices.length !== 0 &&
        this.arrayLengths.wf_resp_arr === 1
      ) {
        this.navDir = NAV_DIR_BACKWARD;
        // Only navigated to Questionnaire and either one or more selections made
        this.resetAll();
      } else if (
        this.prodClassCriteria.current_slide_number === 1 &&
        this.arrayLengths.wf_resp_arr > 1
      ) {
        this.validationMsg = '';
        const showThisData =
          this.prodClassCriteria.workflowResponseCache[
            this.prodClassCriteria.workflowResponseCache.length - 2
          ].response_data;
        // While navigating back when we encounter a multi-select dataset or attribute "multi_select" is "Y" flag multi_select shoulb be set to true.
        this.multi_select = showThisData.multi_select === 'Y';
        // If country is 'Australia' make prodClassCriteria.selectedChoices empty

        this.prodClassCriteria.compositeArrayWrapper.dataArray = [showThisData];
        const choicesObj =
          this.prodClassCriteria.workflowResponseCache[
            this.prodClassCriteria.workflowResponseCache.length - 2
          ].choices;
        // If last element before being popped() (line# 1649 or after this.levelArrayMap.size) is an array then simply set selectedChoices to empty and
        // choiceFlag to false.
        if (
          Array.isArray(
            this.prodClassCriteria.workflowResponseCache[
              this.prodClassCriteria.workflowResponseCache.length - 1
            ].choices
          )
        ) {
          this.prodClassCriteria.selectedChoices = [];
          this.choiceFlag = false;
          this.fireValidations();
        }
        if (!Array.isArray(choicesObj)) {
          this.prodClassCriteria.selectedOptions = choicesObj;
        }
        const didUserSelectRadio = this.arrayLengths.wf_resp_arr === this.levelArrayMap.size;
        this.prodClassCriteria.workflowResponseCache.pop();
        if (didUserSelectRadio) {
          const keys = [...this.searchCriteriaMap.keys()];
          const lastKey = keys[keys.length - 1];
          this.searchCriteriaMap.delete(lastKey);
          this.levelArrayMap.delete(lastKey);
          this.prodClassCriteria.interimClassMap.delete(lastKey);
        }
        this.resetClassInfo();
        this.navDir = NAV_DIR_BACKWARD;
      } else if (this.prodClassCriteria.current_slide_number === 2) {
        // On Summary page and navigating back.
        const showThisData =
          this.prodClassCriteria.workflowResponseCache[
            this.prodClassCriteria.workflowResponseCache.length - 1
          ].response_data;
        this.prodClassCriteria.compositeArrayWrapper.dataArray = [showThisData];
        const choicesObj =
          this.prodClassCriteria.workflowResponseCache[
            this.prodClassCriteria.workflowResponseCache.length - 1
          ].choices;
        this.validationMsg = '';
        this.prodClassCriteria.interimClassDataArray.pop();
        this.prodClassCriteria.selectedOptions = '';
        this.prodClassCriteria.selectedOptions = choicesObj;
        this.prodClassCriteria.current_slide_number -= 1;
        this.navDir = NAV_DIR_BACKWARD;
      }
    },
    /**
     *
     */
    extractClassInfo(valueArray) {
      const classMetaData = {
        class_code: valueArray[3],
        class_notes: valueArray[4],
        class_found:
          valueArray[4] &&
          valueArray[4].length > 0 &&
          valueArray[3] &&
          valueArray[3].length > 0 &&
          valueArray[3].startsWith('Class')
      };
      return classMetaData;
    },
    /**
     * This performs validation when Q1 on any market is selected.
     * This is driven from prod-class-validation-rules.json (disableRules).
     * By using mutually exclusive data sets. If any Yes is selected No should be disabled and if No is selected all yeses
     * should be disabled.
     */
    fireValidations() {
      this.disabledChoices = [];
      let levelSelected = null;
      if (
        this.prodClassCriteria.selectedChoices &&
        this.prodClassCriteria.selectedChoices.length > 0
      ) {
        const allValidationRulesVar = allValidationRules.disableRules;
        for (let vldRlsIdx = 0; vldRlsIdx < allValidationRulesVar.length; vldRlsIdx += 1) {
          const disableRuleIns = allValidationRulesVar[vldRlsIdx];
          if (disableRuleIns.country === this.prodClassCriteria.country) {
            for (
              let loopVar = 0;
              loopVar < this.prodClassCriteria.selectedChoices.length;
              loopVar += 1
            ) {
              const currentChoice = this.prodClassCriteria.selectedChoices[loopVar];
              levelSelected = this.getRuleLevel(currentChoice);
              for (
                let mutExDataIdx = 0;
                mutExDataIdx < disableRuleIns.mutuallyExclusiveResponses.length;
                mutExDataIdx += 1
              ) {
                if (
                  levelSelected === disableRuleIns.mutuallyExclusiveResponses[mutExDataIdx].map_key
                ) {
                  this.disabledChoices =
                    disableRuleIns.mutuallyExclusiveResponses[mutExDataIdx].map_value.split(',');
                } else if (
                  disableRuleIns.mutuallyExclusiveResponses[mutExDataIdx].map_value
                    .split(',')
                    .includes(levelSelected)
                ) {
                  this.disabledChoices.push(
                    disableRuleIns.mutuallyExclusiveResponses[mutExDataIdx].map_key
                  );
                }
              }
            }
          }
        }
      }
    },
    /**
     * Saves data to db.
     */
    async prepareWorkflowData() {
      const prodClassWFDtlsArr = [];
      const valuesSelected = [...this.searchCriteriaMap.values()];
      let stepId = 1;
      for (let loopIndex = 0; loopIndex < valuesSelected.length; loopIndex += 1) {
        let arrayV = [];
        arrayV = valuesSelected[loopIndex];
        let detailObject = {};
        if (Array.isArray(arrayV)) {
          for (let idx = 0; idx < arrayV.length; idx += 1) {
            const selectedOptionsArray = arrayV[idx].split('|');
            detailObject = this.getWorkflowDetailObject(selectedOptionsArray, stepId);
            prodClassWFDtlsArr.push(detailObject);
            stepId += 1;
          }
        } else {
          const selectedOptionsArray = arrayV.split('|');
          detailObject = this.getWorkflowDetailObject(selectedOptionsArray, stepId);
          prodClassWFDtlsArr.push(detailObject);
          stepId += 1;
        }
      }
      this.classWorkFlowData = {
        market: this.prodClassCriteria.country,
        process_start_time: '',
        med_device_type: this.medical_device_type,
        product_name: this.prodClassCriteria.device_name,
        user_id: this.userId,
        account_id: this.account_id,
        class_code: this.summarizedRiskClassRules.resultingRiskClass[0],
        class_notes: this.summarizedRiskClassRules.resultingRiskClass[1],
        rule_ref: this.summarizedRiskRules.highestClassRules[0],
        details: prodClassWFDtlsArr
      };
      await this.syncWorkflowData(this.classWorkFlowData);
    },
    /**
     * Saves kit data to db.
     */
    async prepareWorkflowDataKit() {
      const prodClassWFDtlsArr = [];
      const cachedComponents = [...this.searchCriteriaMapKit.keys()];
      for (let cachedCompIndx = 0; cachedCompIndx < cachedComponents.length; cachedCompIndx += 1) {
        let stepId = 1;
        const valuesSelected = [...this.searchCriteriaMapKit.get(cachedComponents[cachedCompIndx])];
        for (let loopIndex = 0; loopIndex < valuesSelected.length; loopIndex += 1) {
          const arrayV = valuesSelected[loopIndex];
          let detailObject = {};
          const selectedOptionsArray = arrayV[1].split('|');
          detailObject = this.getWorkflowDetailObject(
            selectedOptionsArray,
            stepId,
            cachedComponents[cachedCompIndx]
          );
          prodClassWFDtlsArr.push(detailObject);
          stepId += 1;
        }
        this.prodClassCriteria.current_slide_number = 3;
      }
      const kitHeaderData = {
        market: this.prodClassCriteria.country,
        process_start_time: '',
        med_device_type: this.medical_device_type,
        product_name: this.prodClassCriteria.device_name,
        user_id: this.userId,
        account_id: this.account_id,
        class_code: this.kitClassSummary.classCode,
        class_notes: this.kitClassSummary.classNotes,
        rule_ref: this.summarizedRiskRules.highestClassRules[0],
        details: prodClassWFDtlsArr,
        kit_flag: true
      };
      const response = await postProdClassWorkFlowHeader(kitHeaderData);
      if (response && response.status_code === 200) {
        this.prodClassCriteria.headerId = response.data.header_id;
      }
    },
    /**
     * Utility function to extract detail object from array of values.
     */
    getWorkflowDetailObject(selectedOptionsArray, stepId, compName) {
      const detailObject = {
        intrim_class: selectedOptionsArray[8],
        level: selectedOptionsArray[2],
        question: selectedOptionsArray[7],
        response: selectedOptionsArray[0],
        option_type: selectedOptionsArray[1],
        rule_ref: selectedOptionsArray[6],
        vital_characteristics: selectedOptionsArray[0],
        med_characteristics: selectedOptionsArray[0],
        class_code: selectedOptionsArray[3],
        class_notes: selectedOptionsArray[4],
        component_name: compName,
        step_id: stepId
      };
      return detailObject;
    },
    extractIntrimClassInfoAsArray() {
      const prodClassWFDtlsArr = [];
      const mapIns = this.prodClassCriteria.interimClassMap;
      if (mapIns && [...mapIns.values()]) {
        const valuesSelected = [...mapIns.values()];
        for (let loopIndex = 0; loopIndex < valuesSelected.length; loopIndex += 1) {
          let arrayV = [];
          arrayV = valuesSelected[loopIndex];
          const isArrayCheck = Array.isArray(arrayV);
          if (isArrayCheck === true && loopIndex === 0 && arrayV && arrayV.length !== 0) {
            arrayV.forEach((val) => {
              prodClassWFDtlsArr.push(val);
            });
          } else {
            prodClassWFDtlsArr.push(arrayV);
          }
        }
      }
      return prodClassWFDtlsArr;
    },
    extractLevelArrayDataAsArray(levelArrayMapArg) {
      const prodClassWFDtlsArr = [];
      if (levelArrayMapArg && [...levelArrayMapArg.values()]) {
        const valuesSelected = [...levelArrayMapArg.values()];
        for (let loopIndex = 0; loopIndex < valuesSelected.length; loopIndex += 1) {
          let arrayV = [];
          arrayV = valuesSelected[loopIndex];
          const isArrayCheck = Array.isArray(arrayV);
          if (isArrayCheck === true && arrayV && arrayV.length !== 0) {
            arrayV.forEach((val) => {
              if (val && val.length > 0) {
                prodClassWFDtlsArr.push(val);
              }
            });
          } else if (arrayV && arrayV.length > 0) prodClassWFDtlsArr.push(arrayV);
        }
      }
      return prodClassWFDtlsArr;
    },
    /**
     * Resets class info
     */
    resetClassInfo() {
      this.prodClassCriteria.compositeArrayWrapper.classFoundFlag = false;
      this.prodClassCriteria.compositeArrayWrapper.classNotes = '';
      this.prodClassCriteria.compositeArrayWrapper.classCode = '';
    },
    setOptionInfo() {
      this.optionsFlag = true;
    },
    /**
     * Saves workflow data in DB.
     */
    async syncWorkflowData(classWorkFlowData) {
      this.prodClassCriteria.current_slide_number = 3;
      const response = await postProdClassWorkFlowHeader(classWorkFlowData);
      if (response && response.status_code === 200) {
        this.selectedOptions = '';
        this.prodClassCriteria.headerId = response.data.header_id;
      }
    },
    getCountryNameById(id) {
      const country = this.prodClassCriteria.filteredCountries.find((x) => x.country_value === id);
      return country ? country.country_name : undefined;
    }
  }
};
</script>
<style scoped>
@media (min-width: 375px) and (max-width: 767px) {
  .completed_slide > .crumb > .breadcrumb-img {
    margin-right: 0px;
    height: 30px;
    width: 30px;
  }
  .crumb-trail > li.completed_slide > .crumb {
    padding: 8px;
  }
  .crumb-trail > li:not(:first-child).completed_slide > .crumb {
    padding: 8px 0px 8px 0px;
    text-align: right;
  }
  .crumb-trail > li > .crumb {
    font-size: 0px;
    padding: 12px;
  }
  .crumb-trail > li.is-active-slide > .crumb {
    font-size: 16px;
  }
  .crumb-trail > li.is-active-slide + li > .crumb:after {
    border-left-color: #0b3c61;
  }
  .crumb-trail > li:not(:first-child) > .crumb:after {
    border-top: 22px solid transparent;
    border-bottom: 24px solid transparent;
    border-left: 16px solid #f3f5fb;
  }
  .crumb-trail > li:not(:first-child) > .crumb:before {
    border-top: 22px solid transparent;
    border-bottom: 25px solid transparent;
    border-left: 16px solid #fff;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .crumb > .breadcrumb-img {
    vertical-align: middle;
    margin-right: 2px;
    height: 18px;
    width: 18px;
  }
  .crumb-trail > li > .crumb {
    font-size: 15px;
    padding: 20px 5px 20px 28px;
  }
  .crumb-trail > li:not(:first-child) > .crumb:after {
    left: -11px;
  }
  .crumb-trail > li.is-active-slide > .crumb {
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
  }
  .crumb-trail > li:not(:first-child) > .crumb:before {
    left: -1px;
  }
}
@media only screen and (min-width: 1200px) {
  .reg-intel-report {
    padding-right: 5px;
  }
}
.error {
  color: red;
}
.custom_error_message {
  margin-top: 5px;
  margin-bottom: 0px;
}

.heading {
  margin-top: 15px;
  font-size: 24px;
  line-height: 28px;
  color: #0b3c61;
}
.crumb-trail {
  margin-top: 20px;
  list-style: none;
  padding: 0px;
}
.p-b10 {
  padding-bottom: 10px;
}
.completed_slide > .crumb > .breadcrumb-img {
  display: inline;
}
.breadcrumb-img {
  vertical-align: top;
  margin-right: 6px;
  height: 23px;
  width: 23px;
  display: none;
}
.crumb {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 23px;
  color: #828282;
  padding: 20px;
  position: relative;
  cursor: pointer;
  background: #f3f5fa;
  text-align: center;
}
.is-active-slide > .crumb {
  background: #0b3c61;
  color: #ffffff;
}
.crumb-trail > li.is-active-slide + li > .crumb:after {
  border-left-color: #0b3c61;
}
.crumb-trail > li:first-child > .crumb {
  border-top-left-radius: 40px;
  border-bottom-left-radius: 40px;
}
.crumb-trail > li:last-child > .crumb {
  border-top-right-radius: 40px;
  border-bottom-right-radius: 40px;
}
.crumb-trail > li:not(:first-child) > .crumb {
  margin-left: 10px;
}
li:not(:first-child) > .crumb:after {
  content: '';
  border-top: 30px solid transparent;
  border-bottom: 33px solid transparent;
  border-left: 24px solid #f3f5fa;
  position: absolute;
  left: -10px;
  top: 0;
  z-index: 1;
}
li:not(:first-child) > .crumb:before {
  content: '';
  border-top: 30px solid transparent;
  border-bottom: 33px solid transparent;
  border-left: 24px solid #fff;
  position: absolute;
  left: 0;
  top: 0;
}
.case-slider__navigation {
  position: relative;
  margin-top: 21px;
  margin-bottom: 32px;
}

.padding_rt10_lft0 {
  padding-right: 10px;
  padding-left: 0px;
}
.padding_rt10_lft4 {
  padding-right: 10px;
  padding-left: 4px;
}
.pl-30 {
  padding-right: 0px;
  padding-left: 45px;
}
.padding_rl20 {
  padding-right: 20px;
  padding-left: 20px;
}
.sub_caption {
  padding: 16px 0;
  margin-bottom: 0;
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 19px;
  color: #000000;
}
.sub_caption_bold {
  padding: 16px 0;
  margin-bottom: 0;
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #000000;
}
.margin_bottom_15 {
  margin-bottom: 15px;
}
.margin_top_bottom_15 {
  margin-bottom: 15px;
  margin-top: 6px;
}
.notification_box {
  min-height: 110px;
  position: relative;
  display: block;
  background: #ffffff;
  box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  margin-left: 20px;
  margin: 15px 20px 10px 20px;
  padding: 14px 10px 10px 2px;
}
.error-msg {
  box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}
.sub_heading {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
}
.class_question {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 23px;
  display: flex;
  align-items: center;
  color: #00518a;
}

.class_answer {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
  padding-left: 5px;
  color: rgba(0, 0, 0, 0.7);
  overflow-wrap: normal;
}
.question_details {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.7);
}

.tooltip-width {
  width: 390px !important;
}

::v-deep .tools_check .el-radio__inner:after {
  width: 10px;
  height: 10px;
  min-width: 20px;
  background-color: #0b3c61;
}
.cust-margin {
  margin-bottom: 2px;
}
.required_astric {
  font-size: 12px;
  color: red;
  margin-left: 2px;
  vertical-align: top;
}
.vital-char-style {
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: rgba(0, 0, 0, 0.7);
}
.tf-width-20 {
  width: 20%;
}
.m-t5 {
  margin-bottom: 2px;
  margin-top: 5px;
}
.field-br {
  word-break: break-all;
}
.cb-label {
  display: flex !important;
  flex-direction: row;
  margin-bottom: 1px;
}
.cb-label-add {
  display: contents !important;
  padding-left: 10px;
}
.m-r-14 {
  margin-right: 14px;
}
.m-t-3 {
  margin-top: 3px;
}
.m-l {
  margin-left: 10px;
}

.class-radio__label {
  font-size: 16px;
  padding-left: 10px;
  font-weight: 400;
}
label {
  max-width: 100%;
  margin-bottom: 5px;
}
.radio_placement {
  position: absolute;
}
input[type='label'] {
  margin-right: 14px;
}
input[type='radio'] {
  margin-right: 10px;
  /* min-width: 20px; */
}
</style>
